var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCard3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.5,138.65a8,8,0,0,1,.24-9.82c6.9-8.46,24.41-25,55.58-24.71,30.53.32,48,16.83,55.14,25.73a7.91,7.91,0,0,1-.56,10.55,81.66,81.66,0,0,1-57.1,23.53C76.36,164.25,59.93,147.33,53.5,138.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.93,164.83c-29.71,0-46-16-53.14-25.65h0a8.89,8.89,0,0,1,.26-10.92c7.73-9.49,25.33-25.35,56.28-25,30.52.31,48.08,16.46,55.83,26.05a8.79,8.79,0,0,1-.63,11.75,82.12,82.12,0,0,1-57.72,23.79ZM108.42,105c-29.65,0-46.53,15.24-54,24.38a7.13,7.13,0,0,0-.21,8.73h0c7,9.44,23.08,25.2,52.57,24.91a80.38,80.38,0,0,0,56.47-23.26,7,7,0,0,0,.51-9.36c-7.56-9.35-24.67-25.09-54.45-25.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.92,
    cy: 134.01,
    r: 29.89,
    transform: "translate(-47.53 207.78) rotate(-76.54)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.92,
    cy: 134.02,
    r: 22.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.92,134l17.26-4.67a17.9,17.9,0,1,1-4.62-8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.61,97a48.77,48.77,0,0,1-4.78-4.69,49.55,49.55,0,0,1-4.44-5A46.31,46.31,0,0,1,92.17,92,49.31,49.31,0,0,1,96.61,97Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.43,93.28a20,20,0,0,1-.19-2.84c-.07-1.75-.17-4.16-.33-6.83s-.35-5.08-.49-6.83a19.58,19.58,0,0,1-.15-2.83,15.37,15.37,0,0,1,.48,2.8c.22,1.74.46,4.16.62,6.83s.21,5.1.2,6.86A15.64,15.64,0,0,1,107.43,93.28Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,87.79a50.85,50.85,0,0,1-5.09,4.52,51,51,0,0,1-5.39,4.17A51.62,51.62,0,0,1,121.59,92,48.93,48.93,0,0,1,127,87.79Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.05,147.9c.67-4.83-6.15-8.8-11.27-9.22-2.44-.19-5,.18-7.29-.63-5-1.74-7-8.22-11.9-10.28-3.65-1.54-7.86-.17-11.41,1.62s-7,4-11,4.28c-3.45.22-7.18-1.06-10.2.62-2.24,1.26-3.42,3.84-5.49,5.37s-4.66,1.81-7.18,2-5.11.16-7.4,1.21-4.18,3.46-3.7,5.93Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.47,182c.52-3.79-4.83-6.91-8.86-7.24-1.91-.15-3.91.14-5.73-.49-3.94-1.37-5.51-6.46-9.35-8.08-2.88-1.22-6.18-.14-9,1.27s-5.54,3.16-8.65,3.36c-2.71.17-5.65-.83-8,.49-1.76,1-2.68,3-4.31,4.22a10.27,10.27,0,0,1-5.64,1.53,16,16,0,0,0-5.82,1c-1.8.83-3.29,2.73-2.91,4.67Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.09,55.73c.52-3.79-4.84-6.91-8.86-7.24-1.92-.15-3.91.14-5.73-.49-3.94-1.37-5.51-6.46-9.36-8.08-2.87-1.22-6.18-.14-9,1.27s-5.54,3.16-8.65,3.36c-2.71.17-5.65-.83-8,.49-1.76,1-2.69,3-4.32,4.22a10.24,10.24,0,0,1-5.64,1.53,16,16,0,0,0-5.81,1c-1.8.83-3.29,2.73-2.92,4.67Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.71,234.83c.52-3.8-4.84-6.92-8.86-7.24-1.92-.16-3.91.13-5.73-.5-3.94-1.37-5.51-6.46-9.36-8.08-2.87-1.21-6.18-.14-9,1.27s-5.53,3.16-8.65,3.36c-2.7.18-5.64-.83-8,.49-1.77,1-2.69,3-4.32,4.22a10.18,10.18,0,0,1-5.64,1.53,16.06,16.06,0,0,0-5.82,1c-1.79.83-3.28,2.73-2.91,4.67Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.27,245.52c.63-4.61-5.86-8.39-10.74-8.78-2.33-.19-4.75.16-7-.6-4.78-1.67-6.69-7.84-11.35-9.81-3.48-1.47-7.49-.16-10.87,1.54s-6.72,3.84-10.49,4.08c-3.29.21-6.85-1-9.72.6-2.14,1.2-3.26,3.66-5.24,5.12s-4.44,1.72-6.84,1.85-4.87.16-7,1.15-4,3.31-3.53,5.66Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.25,50.69c.52-3.79-4.83-6.91-8.86-7.24-1.92-.15-3.91.14-5.73-.49-3.94-1.38-5.51-6.47-9.35-8.09-2.88-1.21-6.18-.13-9,1.27s-5.54,3.17-8.65,3.37c-2.71.17-5.65-.83-8,.49-1.76,1-2.69,3-4.31,4.22a10.35,10.35,0,0,1-5.64,1.53,16,16,0,0,0-5.82,1c-1.8.82-3.29,2.72-2.91,4.67Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438.9,
    y: 376.83,
    width: 23.97,
    height: 101.38,
    transform: "translate(901.77 855.05) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 451.11,
    y: 383.94,
    width: 7.29,
    height: 14.04,
    transform: "translate(909.52 781.92) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.55,398c.06,0,.1-3.14.1-7s0-7-.1-7-.09,3.14-.09,7S454.5,398,454.55,398Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.11,388.82a66.48,66.48,0,0,0,7.29,0,66.48,66.48,0,0,0-7.29,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.08,393.84a67.39,67.39,0,0,0,7.34,0,67.39,67.39,0,0,0-7.34,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 451.11,
    y: 402.28,
    width: 7.29,
    height: 14.04,
    transform: "translate(909.52 818.6) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.55,416.32c.06,0,.1-3.14.1-7s0-7-.1-7-.09,3.14-.09,7S454.5,416.32,454.55,416.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.11,407.16a66.48,66.48,0,0,0,7.29,0,66.48,66.48,0,0,0-7.29,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.08,412.18a67.39,67.39,0,0,0,7.34,0,67.39,67.39,0,0,0-7.34,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 451.11,
    y: 420.62,
    width: 7.29,
    height: 14.04,
    transform: "translate(909.52 855.29) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.55,434.66c.06,0,.1-3.14.1-7s0-7-.1-7-.09,3.15-.09,7S454.5,434.66,454.55,434.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.11,425.5a66.48,66.48,0,0,0,7.29,0,66.48,66.48,0,0,0-7.29,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.08,430.52a67.39,67.39,0,0,0,7.34,0s-1.64-.09-3.67-.09S451.08,430.47,451.08,430.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 451.11,
    y: 438.96,
    width: 7.29,
    height: 14.04,
    transform: "translate(909.52 891.97) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.55,453c.06,0,.1-3.15.1-7s0-7-.1-7-.09,3.15-.09,7S454.5,453,454.55,453Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.11,443.84a66.48,66.48,0,0,0,7.29,0s-1.63-.09-3.64-.09S451.11,443.79,451.11,443.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.08,448.86a67.39,67.39,0,0,0,7.34,0c0-.05-1.64-.09-3.67-.09S451.08,448.81,451.08,448.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.7,
    y: 376.83,
    width: 17.47,
    height: 101.38,
    transform: "translate(874.87 855.05) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433.46,
    y: 383.94,
    width: 7.29,
    height: 14.04,
    transform: "translate(874.2 781.92) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.89,398c.06,0,.1-3.14.1-7s0-7-.1-7-.09,3.14-.09,7S436.84,398,436.89,398Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.46,388.82a66.3,66.3,0,0,0,7.28,0,66.3,66.3,0,0,0-7.28,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.42,393.84a67.58,67.58,0,0,0,7.35,0,67.58,67.58,0,0,0-7.35,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433.46,
    y: 402.43,
    width: 7.29,
    height: 14.04,
    transform: "translate(874.2 818.91) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.89,416.47c.06,0,.1-3.14.1-7s0-7-.1-7-.09,3.15-.09,7S436.84,416.47,436.89,416.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.46,407.31a66.3,66.3,0,0,0,7.28,0,66.3,66.3,0,0,0-7.28,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.42,412.33a67.58,67.58,0,0,0,7.35,0,67.58,67.58,0,0,0-7.35,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433.46,
    y: 420.92,
    width: 7.29,
    height: 14.04,
    transform: "translate(874.2 855.89) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.89,435c.06,0,.1-3.15.1-7s0-7-.1-7-.09,3.15-.09,7S436.84,435,436.89,435Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.46,425.8a66.3,66.3,0,0,0,7.28,0,66.3,66.3,0,0,0-7.28,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.42,430.82a67.58,67.58,0,0,0,7.35,0c0-.05-1.65-.09-3.68-.09S433.42,430.77,433.42,430.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433.46,
    y: 439.42,
    width: 7.29,
    height: 14.04,
    transform: "translate(874.2 892.87) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.89,453.46c.06,0,.1-3.15.1-7s0-7-.1-7-.09,3.14-.09,7S436.84,453.46,436.89,453.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.46,444.29a66.3,66.3,0,0,0,7.28,0c0-.05-1.63-.09-3.64-.09S433.46,444.24,433.46,444.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.42,449.32c0,.05,1.64.09,3.67.09s3.68,0,3.68-.09a67.58,67.58,0,0,0-7.35,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 451.11,
    y: 457.31,
    width: 7.29,
    height: 14.04,
    transform: "translate(909.52 928.65) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.55,471.35c.06,0,.1-3.15.1-7s0-7-.1-7-.09,3.14-.09,7S454.5,471.35,454.55,471.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.11,462.18a66.48,66.48,0,0,0,7.29,0c0-.05-1.63-.09-3.64-.09S451.11,462.13,451.11,462.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.08,467.21c0,.05,1.64.09,3.67.09s3.67,0,3.67-.09a67.39,67.39,0,0,0-7.34,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433.46,
    y: 457.91,
    width: 7.29,
    height: 14.04,
    transform: "translate(874.2 929.86) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.89,472c.06,0,.1-3.14.1-7s0-7-.1-7-.09,3.14-.09,7S436.84,472,436.89,472Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.46,462.79s1.63.09,3.64.09,3.64,0,3.64-.09a66.3,66.3,0,0,0-7.28,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.42,467.81c0,.05,1.64.09,3.67.09s3.68,0,3.68-.09a67.58,67.58,0,0,0-7.35,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.88,
    y: 376.83,
    width: 23.97,
    height: 101.38,
    transform: "translate(669.74 855.05) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.1,
    y: 383.94,
    width: 7.29,
    height: 14.04,
    transform: "translate(677.49 781.92) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.54,398s.1-3.14.1-7-.05-7-.1-7-.1,3.14-.1,7S338.49,398,338.54,398Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.1,388.82a66.48,66.48,0,0,0,7.29,0,66.48,66.48,0,0,0-7.29,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.06,393.84a67.58,67.58,0,0,0,7.35,0,67.58,67.58,0,0,0-7.35,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.1,
    y: 402.28,
    width: 7.29,
    height: 14.04,
    transform: "translate(677.49 818.6) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.54,416.32s.1-3.14.1-7-.05-7-.1-7-.1,3.14-.1,7S338.49,416.32,338.54,416.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.1,407.16a66.48,66.48,0,0,0,7.29,0,66.48,66.48,0,0,0-7.29,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.06,412.18a67.58,67.58,0,0,0,7.35,0,67.58,67.58,0,0,0-7.35,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.1,
    y: 420.62,
    width: 7.29,
    height: 14.04,
    transform: "translate(677.49 855.29) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.54,434.66s.1-3.14.1-7-.05-7-.1-7-.1,3.15-.1,7S338.49,434.66,338.54,434.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.1,425.5a66.48,66.48,0,0,0,7.29,0,66.48,66.48,0,0,0-7.29,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.06,430.52a67.58,67.58,0,0,0,7.35,0s-1.64-.09-3.67-.09S335.06,430.47,335.06,430.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.1,
    y: 438.96,
    width: 7.29,
    height: 14.04,
    transform: "translate(677.49 891.97) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.54,453s.1-3.15.1-7-.05-7-.1-7-.1,3.15-.1,7S338.49,453,338.54,453Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.1,443.84a66.48,66.48,0,0,0,7.29,0s-1.63-.09-3.64-.09S335.1,443.79,335.1,443.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.06,448.86a67.58,67.58,0,0,0,7.35,0c0-.05-1.64-.09-3.67-.09S335.06,448.81,335.06,448.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.69,
    y: 376.83,
    width: 17.47,
    height: 101.38,
    transform: "translate(642.84 855.05) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.44,
    y: 383.94,
    width: 7.29,
    height: 14.04,
    transform: "translate(642.18 781.92) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.88,398c.06,0,.1-3.14.1-7s0-7-.1-7-.1,3.14-.1,7S320.83,398,320.88,398Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.44,388.82a66.48,66.48,0,0,0,7.29,0,66.48,66.48,0,0,0-7.29,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.41,393.84a67.39,67.39,0,0,0,7.34,0,67.39,67.39,0,0,0-7.34,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.44,
    y: 402.43,
    width: 7.29,
    height: 14.04,
    transform: "translate(642.18 818.91) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.88,416.47c.06,0,.1-3.14.1-7s0-7-.1-7-.1,3.15-.1,7S320.83,416.47,320.88,416.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.44,407.31a66.48,66.48,0,0,0,7.29,0,66.48,66.48,0,0,0-7.29,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.41,412.33a67.39,67.39,0,0,0,7.34,0,67.39,67.39,0,0,0-7.34,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.44,
    y: 420.92,
    width: 7.29,
    height: 14.04,
    transform: "translate(642.18 855.89) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.88,435c.06,0,.1-3.15.1-7s0-7-.1-7-.1,3.15-.1,7S320.83,435,320.88,435Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.44,425.8a66.48,66.48,0,0,0,7.29,0,66.48,66.48,0,0,0-7.29,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.41,430.82a67.39,67.39,0,0,0,7.34,0c0-.05-1.64-.09-3.67-.09S317.41,430.77,317.41,430.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.44,
    y: 439.42,
    width: 7.29,
    height: 14.04,
    transform: "translate(642.18 892.87) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.88,453.46c.06,0,.1-3.15.1-7s0-7-.1-7-.1,3.14-.1,7S320.83,453.46,320.88,453.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.44,444.29a66.48,66.48,0,0,0,7.29,0c0-.05-1.63-.09-3.64-.09S317.44,444.24,317.44,444.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.41,449.32c0,.05,1.64.09,3.67.09s3.67,0,3.67-.09a67.39,67.39,0,0,0-7.34,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.1,
    y: 457.31,
    width: 7.29,
    height: 14.04,
    transform: "translate(677.49 928.65) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.54,471.35s.1-3.15.1-7-.05-7-.1-7-.1,3.14-.1,7S338.49,471.35,338.54,471.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.1,462.18a66.48,66.48,0,0,0,7.29,0c0-.05-1.63-.09-3.64-.09S335.1,462.13,335.1,462.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.06,467.21c0,.05,1.65.09,3.68.09s3.67,0,3.67-.09a67.58,67.58,0,0,0-7.35,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.44,
    y: 457.91,
    width: 7.29,
    height: 14.04,
    transform: "translate(642.18 929.86) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.88,472c.06,0,.1-3.14.1-7s0-7-.1-7-.1,3.14-.1,7S320.83,472,320.88,472Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.44,462.79s1.64.09,3.65.09,3.64,0,3.64-.09a66.48,66.48,0,0,0-7.29,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.41,467.81c0,.05,1.64.09,3.67.09s3.67,0,3.67-.09a67.39,67.39,0,0,0-7.34,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.18,
    y: 347.25,
    width: 31.12,
    height: 131.58,
    transform: "translate(835.47 826.09) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.04,
    y: 356.48,
    width: 9.46,
    height: 18.22,
    transform: "translate(845.53 731.18) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.5,374.7c.07,0,.12-4.08.12-9.11s-.05-9.11-.12-9.11-.13,4.07-.13,9.11S422.43,374.7,422.5,374.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418,362.81a93.08,93.08,0,0,0,9.45,0,85.93,85.93,0,0,0-9.45,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418,369.32a87.39,87.39,0,0,0,9.53,0,94.67,94.67,0,0,0-9.53,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.04,
    y: 380.28,
    width: 9.46,
    height: 18.22,
    transform: "translate(845.53 778.79) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.5,398.51c.07,0,.12-4.08.12-9.12s-.05-9.11-.12-9.11-.13,4.08-.13,9.11S422.43,398.51,422.5,398.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418,386.61a85.93,85.93,0,0,0,9.45,0,93.08,93.08,0,0,0-9.45,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418,393.13a87.39,87.39,0,0,0,9.53,0,87.39,87.39,0,0,0-9.53,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.04,
    y: 404.09,
    width: 9.46,
    height: 18.22,
    transform: "translate(845.53 826.4) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.5,422.31c.07,0,.12-4.08.12-9.11s-.05-9.11-.12-9.11-.13,4.07-.13,9.11S422.43,422.31,422.5,422.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418,410.42a93.08,93.08,0,0,0,9.45,0,85.93,85.93,0,0,0-9.45,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418,416.93a87.39,87.39,0,0,0,9.53,0,94.67,94.67,0,0,0-9.53,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.04,
    y: 427.89,
    width: 9.46,
    height: 18.22,
    transform: "translate(845.53 874.01) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.5,446.12c.07,0,.12-4.08.12-9.12s-.05-9.11-.12-9.11-.13,4.08-.13,9.11S422.43,446.12,422.5,446.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418,434.22a85.93,85.93,0,0,0,9.45,0,93.08,93.08,0,0,0-9.45,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418,440.74a87.39,87.39,0,0,0,9.53,0,87.39,87.39,0,0,0-9.53,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.94,
    y: 347.25,
    width: 22.67,
    height: 131.58,
    transform: "translate(800.56 826.09) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.12,
    y: 356.48,
    width: 9.46,
    height: 18.22,
    transform: "translate(799.69 731.18) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.58,374.7c.07,0,.13-4.08.13-9.11s-.06-9.11-.13-9.11-.13,4.07-.13,9.11S399.51,374.7,399.58,374.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.12,362.81a93.28,93.28,0,0,0,9.46,0,86.11,86.11,0,0,0-9.46,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.07,369.32a87.39,87.39,0,0,0,9.53,0,94.67,94.67,0,0,0-9.53,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.12,
    y: 380.48,
    width: 9.46,
    height: 18.22,
    transform: "translate(799.69 779.18) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.58,398.7c.07,0,.13-4.08.13-9.11s-.06-9.11-.13-9.11-.13,4.07-.13,9.11S399.51,398.7,399.58,398.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.12,386.81a93.28,93.28,0,0,0,9.46,0,86.11,86.11,0,0,0-9.46,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.07,393.33c0,.06,2.13.12,4.77.12s4.76-.06,4.76-.12a87.39,87.39,0,0,0-9.53,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.12,
    y: 404.48,
    width: 9.46,
    height: 18.22,
    transform: "translate(799.69 827.18) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.58,422.7c.07,0,.13-4.08.13-9.11s-.06-9.11-.13-9.11-.13,4.08-.13,9.11S399.51,422.7,399.58,422.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.12,410.81a93.28,93.28,0,0,0,9.46,0,86.11,86.11,0,0,0-9.46,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.07,417.33a94.67,94.67,0,0,0,9.53,0,87.39,87.39,0,0,0-9.53,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.12,
    y: 428.48,
    width: 9.46,
    height: 18.22,
    transform: "translate(799.69 875.18) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.58,446.7c.07,0,.13-4.08.13-9.11s-.06-9.11-.13-9.11-.13,4.08-.13,9.11S399.51,446.7,399.58,446.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.12,434.81a93.28,93.28,0,0,0,9.46,0,86.11,86.11,0,0,0-9.46,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.07,441.33a94.67,94.67,0,0,0,9.53,0,87.39,87.39,0,0,0-9.53,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.04,
    y: 451.7,
    width: 9.46,
    height: 18.22,
    transform: "translate(845.53 921.62) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.5,469.92c.07,0,.12-4.08.12-9.11s-.05-9.11-.12-9.11-.13,4.07-.13,9.11S422.43,469.92,422.5,469.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418,458a93.08,93.08,0,0,0,9.45,0,85.93,85.93,0,0,0-9.45,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418,464.54a87.39,87.39,0,0,0,9.53,0c0-.06-2.13-.12-4.77-.12S418,464.48,418,464.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.12,
    y: 452.48,
    width: 9.46,
    height: 18.22,
    transform: "translate(799.69 923.18) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.58,470.7c.07,0,.13-4.08.13-9.11s-.06-9.11-.13-9.11-.13,4.08-.13,9.11S399.51,470.7,399.58,470.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.12,458.81a93.28,93.28,0,0,0,9.46,0,86.11,86.11,0,0,0-9.46,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.07,465.33a94.67,94.67,0,0,0,9.53,0,87.39,87.39,0,0,0-9.53,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.72,
    y: 259.92,
    width: 33.02,
    height: 139.63,
    transform: "translate(750.45 659.47) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.54,
    y: 269.71,
    width: 10.04,
    height: 19.34,
    transform: "translate(761.12 558.76) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.28,289.05c.07,0,.13-4.33.13-9.67s-.06-9.67-.13-9.67-.13,4.33-.13,9.67S380.2,289.05,380.28,289.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.54,276.43a97,97,0,0,0,10,0,90.07,90.07,0,0,0-10,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.49,283.34a91.51,91.51,0,0,0,10.12,0,98.54,98.54,0,0,0-10.12,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.54,
    y: 294.97,
    width: 10.04,
    height: 19.34,
    transform: "translate(761.12 609.28) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.28,314.31c.07,0,.13-4.33.13-9.67s-.06-9.67-.13-9.67-.13,4.33-.13,9.67S380.2,314.31,380.28,314.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.54,301.69a97,97,0,0,0,10,0,90.07,90.07,0,0,0-10,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.49,308.6a91.51,91.51,0,0,0,10.12,0,98.54,98.54,0,0,0-10.12,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.54,
    y: 320.23,
    width: 10.04,
    height: 19.34,
    transform: "translate(761.12 659.8) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.28,339.57c.07,0,.13-4.33.13-9.67s-.06-9.67-.13-9.67-.13,4.33-.13,9.67S380.2,339.57,380.28,339.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.54,327a97,97,0,0,0,10,0,90.07,90.07,0,0,0-10,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.49,333.86a91.51,91.51,0,0,0,10.12,0,98.54,98.54,0,0,0-10.12,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.54,
    y: 345.49,
    width: 10.04,
    height: 19.34,
    transform: "translate(761.12 710.32) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.28,364.83c.07,0,.13-4.33.13-9.67s-.06-9.67-.13-9.67-.13,4.33-.13,9.67S380.2,364.83,380.28,364.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.54,352.21a97,97,0,0,0,10,0,90.07,90.07,0,0,0-10,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.49,359.12a91.51,91.51,0,0,0,10.12,0,98.54,98.54,0,0,0-10.12,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.67,
    y: 259.92,
    width: 24.06,
    height: 139.63,
    transform: "translate(713.4 659.47) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.22,
    y: 269.71,
    width: 10.04,
    height: 19.34,
    transform: "translate(712.49 558.76) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356,289.05c.07,0,.13-4.33.13-9.67s-.06-9.67-.13-9.67-.13,4.33-.13,9.67S355.89,289.05,356,289.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.22,276.43a97,97,0,0,0,10,0,90.07,90.07,0,0,0-10,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.17,283.34a91.51,91.51,0,0,0,10.12,0,98.54,98.54,0,0,0-10.12,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.22,
    y: 295.18,
    width: 10.04,
    height: 19.34,
    transform: "translate(712.49 609.69) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356,314.51c.07,0,.13-4.32.13-9.66s-.06-9.67-.13-9.67-.13,4.32-.13,9.67S355.89,314.51,356,314.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.22,301.89a90.07,90.07,0,0,0,10,0,97,97,0,0,0-10,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.17,308.81a91.51,91.51,0,0,0,10.12,0,98.54,98.54,0,0,0-10.12,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.22,
    y: 320.64,
    width: 10.04,
    height: 19.34,
    transform: "translate(712.49 660.63) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356,340c.07,0,.13-4.33.13-9.67s-.06-9.67-.13-9.67-.13,4.33-.13,9.67S355.89,340,356,340Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.22,327.36a90.07,90.07,0,0,0,10,0,97,97,0,0,0-10,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.17,334.28a98.54,98.54,0,0,0,10.12,0,91.51,91.51,0,0,0-10.12,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.22,
    y: 346.11,
    width: 10.04,
    height: 19.34,
    transform: "translate(712.49 711.56) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356,365.45c.07,0,.13-4.33.13-9.67s-.06-9.67-.13-9.67-.13,4.33-.13,9.67S355.89,365.45,356,365.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.22,352.83a97,97,0,0,0,10,0,97,97,0,0,0-10,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.17,359.75a98.54,98.54,0,0,0,10.12,0,91.51,91.51,0,0,0-10.12,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.54,
    y: 370.75,
    width: 10.04,
    height: 19.34,
    transform: "translate(761.12 760.84) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.28,390.09c.07,0,.13-4.33.13-9.67s-.06-9.67-.13-9.67-.13,4.33-.13,9.67S380.2,390.09,380.28,390.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.54,377.47a97,97,0,0,0,10,0,97,97,0,0,0-10,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.49,384.39a98.54,98.54,0,0,0,10.12,0,91.51,91.51,0,0,0-10.12,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.22,
    y: 371.58,
    width: 10.04,
    height: 19.34,
    transform: "translate(712.49 762.5) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356,390.92c.07,0,.13-4.33.13-9.67s-.06-9.67-.13-9.67-.13,4.33-.13,9.67S355.89,390.92,356,390.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.22,378.3a97,97,0,0,0,10,0,90.07,90.07,0,0,0-10,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.17,385.21a91.51,91.51,0,0,0,10.12,0,98.54,98.54,0,0,0-10.12,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.72,
    y: 338.69,
    width: 33.02,
    height: 139.63,
    transform: "translate(750.45 817) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.54,
    y: 348.47,
    width: 10.04,
    height: 19.34,
    transform: "translate(761.12 716.29) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.28,367.81c.07,0,.13-4.33.13-9.67s-.06-9.67-.13-9.67-.13,4.33-.13,9.67S380.2,367.81,380.28,367.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.54,355.19a90.07,90.07,0,0,0,10,0,97,97,0,0,0-10,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.49,362.11a98.54,98.54,0,0,0,10.12,0,91.51,91.51,0,0,0-10.12,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.54,
    y: 373.73,
    width: 10.04,
    height: 19.34,
    transform: "translate(761.12 766.81) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.28,393.07c.07,0,.13-4.33.13-9.67s-.06-9.67-.13-9.67-.13,4.33-.13,9.67S380.2,393.07,380.28,393.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.54,380.45a90.07,90.07,0,0,0,10,0,97,97,0,0,0-10,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.49,387.37a98.54,98.54,0,0,0,10.12,0,91.51,91.51,0,0,0-10.12,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.54,
    y: 398.99,
    width: 10.04,
    height: 19.34,
    transform: "translate(761.12 817.33) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.28,418.33c.07,0,.13-4.33.13-9.67s-.06-9.67-.13-9.67-.13,4.33-.13,9.67S380.2,418.33,380.28,418.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.54,405.71a90.07,90.07,0,0,0,10,0,97,97,0,0,0-10,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.49,412.63a98.54,98.54,0,0,0,10.12,0,98.54,98.54,0,0,0-10.12,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.54,
    y: 424.26,
    width: 10.04,
    height: 19.34,
    transform: "translate(761.12 867.85) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.28,443.59c.07,0,.13-4.33.13-9.66s-.06-9.67-.13-9.67-.13,4.32-.13,9.67S380.2,443.59,380.28,443.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.54,431a90.07,90.07,0,0,0,10,0,97,97,0,0,0-10,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.49,437.89a98.54,98.54,0,0,0,10.12,0,98.54,98.54,0,0,0-10.12,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.67,
    y: 338.69,
    width: 24.06,
    height: 139.63,
    transform: "translate(713.4 817) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.22,
    y: 348.47,
    width: 10.04,
    height: 19.34,
    transform: "translate(712.49 716.29) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356,367.81c.07,0,.13-4.33.13-9.67s-.06-9.67-.13-9.67-.13,4.33-.13,9.67S355.89,367.81,356,367.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.22,355.19a90.07,90.07,0,0,0,10,0,97,97,0,0,0-10,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.17,362.11a98.54,98.54,0,0,0,10.12,0,91.51,91.51,0,0,0-10.12,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.22,
    y: 373.94,
    width: 10.04,
    height: 19.34,
    transform: "translate(712.49 767.22) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356,393.28c.07,0,.13-4.33.13-9.67s-.06-9.67-.13-9.67-.13,4.33-.13,9.67S355.89,393.28,356,393.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.22,380.66a97,97,0,0,0,10,0,97,97,0,0,0-10,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.17,387.58a98.54,98.54,0,0,0,10.12,0,91.51,91.51,0,0,0-10.12,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.22,
    y: 399.41,
    width: 10.04,
    height: 19.34,
    transform: "translate(712.49 818.16) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356,418.75c.07,0,.13-4.33.13-9.67s-.06-9.67-.13-9.67-.13,4.33-.13,9.67S355.89,418.75,356,418.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.22,406.13a97,97,0,0,0,10,0,90.07,90.07,0,0,0-10,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.17,413a91.51,91.51,0,0,0,10.12,0,98.54,98.54,0,0,0-10.12,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.22,
    y: 424.88,
    width: 10.04,
    height: 19.34,
    transform: "translate(712.49 869.09) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356,444.22c.07,0,.13-4.33.13-9.67s-.06-9.67-.13-9.67-.13,4.33-.13,9.67S355.89,444.22,356,444.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.22,431.6a97,97,0,0,0,10,0,90.07,90.07,0,0,0-10,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.17,438.51a91.51,91.51,0,0,0,10.12,0,98.54,98.54,0,0,0-10.12,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.54,
    y: 449.52,
    width: 10.04,
    height: 19.34,
    transform: "translate(761.12 918.37) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.28,468.85c.07,0,.13-4.32.13-9.66s-.06-9.67-.13-9.67-.13,4.32-.13,9.67S380.2,468.85,380.28,468.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.54,456.23a90.07,90.07,0,0,0,10,0,97,97,0,0,0-10,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.49,463.15a98.54,98.54,0,0,0,10.12,0,98.54,98.54,0,0,0-10.12,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.22,
    y: 450.34,
    width: 10.04,
    height: 19.34,
    transform: "translate(712.49 920.03) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356,469.68c.07,0,.13-4.33.13-9.67s-.06-9.67-.13-9.67-.13,4.33-.13,9.67S355.89,469.68,356,469.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.22,457.06a90.07,90.07,0,0,0,10,0,97,97,0,0,0-10,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.17,464a98.54,98.54,0,0,0,10.12,0,98.54,98.54,0,0,0-10.12,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.92,
    y: 356.1,
    width: 29.4,
    height: 124.33,
    transform: "translate(117.24 836.52) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.9,
    y: 364.81,
    width: 8.94,
    height: 17.22,
    transform: "translate(126.74 746.84) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.12,382c.07,0,.12-3.85.12-8.61s-.05-8.61-.12-8.61-.12,3.86-.12,8.61S63.05,382,63.12,382Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9,370.8c0,.06,2,.11,4.47.11s4.47-.05,4.47-.11a40.57,40.57,0,0,0-4.47-.12A40.57,40.57,0,0,0,58.9,370.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.86,377a41.07,41.07,0,0,0,4.5.12,41.33,41.33,0,0,0,4.51-.12,44.6,44.6,0,0,0-4.51-.12A44.31,44.31,0,0,0,58.86,377Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.9,
    y: 387.31,
    width: 8.94,
    height: 17.22,
    transform: "translate(126.74 791.83) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.12,404.52c.07,0,.12-3.85.12-8.6s-.05-8.61-.12-8.61-.12,3.85-.12,8.61S63.05,404.52,63.12,404.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9,393.29a43.78,43.78,0,0,0,4.47.12,43.78,43.78,0,0,0,4.47-.12,40.57,40.57,0,0,0-4.47-.12A40.57,40.57,0,0,0,58.9,393.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.86,399.45a44.31,44.31,0,0,0,4.5.12,44.6,44.6,0,0,0,4.51-.12,41.33,41.33,0,0,0-4.51-.12A41.07,41.07,0,0,0,58.86,399.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.9,
    y: 409.8,
    width: 8.94,
    height: 17.22,
    transform: "translate(126.74 836.82) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.12,427c.07,0,.12-3.86.12-8.61s-.05-8.61-.12-8.61-.12,3.85-.12,8.61S63.05,427,63.12,427Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9,415.78a40.57,40.57,0,0,0,4.47.12,40.57,40.57,0,0,0,4.47-.12,40.57,40.57,0,0,0-4.47-.12A40.57,40.57,0,0,0,58.9,415.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.86,421.94a44.31,44.31,0,0,0,4.5.12,44.6,44.6,0,0,0,4.51-.12,41.33,41.33,0,0,0-4.51-.12A41.07,41.07,0,0,0,58.86,421.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.9,
    y: 432.29,
    width: 8.94,
    height: 17.22,
    transform: "translate(126.74 881.8) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.12,449.51c.07,0,.12-3.86.12-8.61s-.05-8.61-.12-8.61S63,436.14,63,440.9,63.05,449.51,63.12,449.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9,438.27a40.57,40.57,0,0,0,4.47.12,40.57,40.57,0,0,0,4.47-.12,43.78,43.78,0,0,0-4.47-.12A43.78,43.78,0,0,0,58.9,438.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.86,444.43a41.07,41.07,0,0,0,4.5.12,41.33,41.33,0,0,0,4.51-.12,44.6,44.6,0,0,0-4.51-.12A44.31,44.31,0,0,0,58.86,444.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.42,
    y: 356.1,
    width: 21.42,
    height: 124.33,
    transform: "translate(84.25 836.52) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.25,
    y: 364.81,
    width: 8.94,
    height: 17.22,
    transform: "translate(83.43 746.84) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.46,382c.07,0,.12-3.85.12-8.61s0-8.61-.12-8.61-.11,3.86-.11,8.61S41.4,382,41.46,382Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.25,370.8c0,.06,2,.11,4.47.11s4.46-.05,4.46-.11a40.46,40.46,0,0,0-4.46-.12A40.57,40.57,0,0,0,37.25,370.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2,377a41.33,41.33,0,0,0,4.51.12,41.22,41.22,0,0,0,4.5-.12,44.48,44.48,0,0,0-4.5-.12A44.6,44.6,0,0,0,37.2,377Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.25,
    y: 387.49,
    width: 8.94,
    height: 17.22,
    transform: "translate(83.43 792.2) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.46,404.71c.07,0,.12-3.86.12-8.61s0-8.61-.12-8.61-.11,3.85-.11,8.61S41.4,404.71,41.46,404.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.25,393.47a40.57,40.57,0,0,0,4.47.12,40.46,40.46,0,0,0,4.46-.12,43.66,43.66,0,0,0-4.46-.12A43.78,43.78,0,0,0,37.25,393.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2,399.63a41.33,41.33,0,0,0,4.51.12,41.22,41.22,0,0,0,4.5-.12,41.22,41.22,0,0,0-4.5-.12A41.33,41.33,0,0,0,37.2,399.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.25,
    y: 410.17,
    width: 8.94,
    height: 17.22,
    transform: "translate(83.43 837.55) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.46,427.39c.07,0,.12-3.86.12-8.61s0-8.61-.12-8.61-.11,3.85-.11,8.61S41.4,427.39,41.46,427.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.25,416.15a40.57,40.57,0,0,0,4.47.12,40.46,40.46,0,0,0,4.46-.12,40.46,40.46,0,0,0-4.46-.12A40.57,40.57,0,0,0,37.25,416.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2,422.31a44.6,44.6,0,0,0,4.51.12,44.48,44.48,0,0,0,4.5-.12,41.22,41.22,0,0,0-4.5-.12A41.33,41.33,0,0,0,37.2,422.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.25,
    y: 432.84,
    width: 8.94,
    height: 17.22,
    transform: "translate(83.43 882.91) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.46,450.06c.07,0,.12-3.85.12-8.61s0-8.61-.12-8.61-.11,3.86-.11,8.61S41.4,450.06,41.46,450.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.25,438.83a43.78,43.78,0,0,0,4.47.12,43.66,43.66,0,0,0,4.46-.12,40.46,40.46,0,0,0-4.46-.12A40.57,40.57,0,0,0,37.25,438.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2,445a41.33,41.33,0,0,0,4.51.12,41.22,41.22,0,0,0,4.5-.12c0-.06-2-.11-4.5-.11S37.2,444.92,37.2,445Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.9,
    y: 454.78,
    width: 8.94,
    height: 17.22,
    transform: "translate(126.74 926.79) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.12,472c.07,0,.12-3.85.12-8.61s-.05-8.61-.12-8.61-.12,3.86-.12,8.61S63.05,472,63.12,472Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9,460.77c0,.06,2,.11,4.47.11s4.47-.05,4.47-.11a40.57,40.57,0,0,0-4.47-.12A40.57,40.57,0,0,0,58.9,460.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.86,466.92a41.07,41.07,0,0,0,4.5.12,41.33,41.33,0,0,0,4.51-.12,44.6,44.6,0,0,0-4.51-.12A44.31,44.31,0,0,0,58.86,466.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.25,
    y: 455.52,
    width: 8.94,
    height: 17.22,
    transform: "translate(83.43 928.26) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.46,472.74c.07,0,.12-3.85.12-8.61s0-8.61-.12-8.61-.11,3.86-.11,8.61S41.4,472.74,41.46,472.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.25,461.5a40.57,40.57,0,0,0,4.47.12,40.46,40.46,0,0,0,4.46-.12,43.66,43.66,0,0,0-4.46-.12A43.78,43.78,0,0,0,37.25,461.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2,467.66a41.33,41.33,0,0,0,4.51.12,41.22,41.22,0,0,0,4.5-.12,44.48,44.48,0,0,0-4.5-.12A44.6,44.6,0,0,0,37.2,467.66Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--City--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 186.82,
    y: 262.71,
    width: 35.34,
    height: 149.46,
    transform: "translate(408.98 674.88) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.83,
    y: 273.19,
    width: 10.74,
    height: 20.7,
    transform: "translate(420.41 567.08) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.9,293.89c.08,0,.15-4.64.15-10.35s-.07-10.35-.15-10.35-.14,4.63-.14,10.35S209.82,293.89,209.9,293.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.83,280.38a50.83,50.83,0,0,0,5.37.14,51,51,0,0,0,5.38-.14,51,51,0,0,0-5.38-.14A50.83,50.83,0,0,0,204.83,280.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.78,287.78a49.73,49.73,0,0,0,5.41.15,50,50,0,0,0,5.42-.15,51.74,51.74,0,0,0-5.42-.14A51.46,51.46,0,0,0,204.78,287.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.83,
    y: 300.23,
    width: 10.74,
    height: 20.7,
    transform: "translate(420.41 621.15) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.9,320.93c.08,0,.15-4.64.15-10.35s-.07-10.35-.15-10.35-.14,4.63-.14,10.35S209.82,320.93,209.9,320.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.83,307.42a50.83,50.83,0,0,0,5.37.14,51,51,0,0,0,5.38-.14,49.23,49.23,0,0,0-5.38-.15A49.12,49.12,0,0,0,204.83,307.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.78,314.82a51.46,51.46,0,0,0,5.41.14,51.74,51.74,0,0,0,5.42-.14,51.74,51.74,0,0,0-5.42-.14A51.46,51.46,0,0,0,204.78,314.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.83,
    y: 327.26,
    width: 10.74,
    height: 20.7,
    transform: "translate(420.41 675.23) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.9,348c.08,0,.15-4.63.15-10.35s-.07-10.35-.15-10.35-.14,4.64-.14,10.35S209.82,348,209.9,348Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.83,334.46a50.83,50.83,0,0,0,5.37.14,51,51,0,0,0,5.38-.14,49.23,49.23,0,0,0-5.38-.15A49.12,49.12,0,0,0,204.83,334.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.78,341.86a51.46,51.46,0,0,0,5.41.14,51.74,51.74,0,0,0,5.42-.14,51.74,51.74,0,0,0-5.42-.14A51.46,51.46,0,0,0,204.78,341.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.83,
    y: 354.3,
    width: 10.74,
    height: 20.7,
    transform: "translate(420.41 729.3) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.9,375c.08,0,.15-4.63.15-10.35s-.07-10.35-.15-10.35-.14,4.64-.14,10.35S209.82,375,209.9,375Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.83,361.49a49.12,49.12,0,0,0,5.37.15,49.23,49.23,0,0,0,5.38-.15,51,51,0,0,0-5.38-.14A50.83,50.83,0,0,0,204.83,361.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.78,368.9a51.46,51.46,0,0,0,5.41.14,51.74,51.74,0,0,0,5.42-.14,50,50,0,0,0-5.42-.15A49.73,49.73,0,0,0,204.78,368.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.79,
    y: 262.71,
    width: 25.75,
    height: 149.46,
    transform: "translate(369.33 674.88) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.8,
    y: 273.19,
    width: 10.74,
    height: 20.7,
    transform: "translate(368.35 567.08) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.87,293.89c.08,0,.14-4.64.14-10.35s-.06-10.35-.14-10.35-.14,4.63-.14,10.35S183.79,293.89,183.87,293.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.8,280.38a50.83,50.83,0,0,0,5.37.14,50.67,50.67,0,0,0,5.37-.14,50.67,50.67,0,0,0-5.37-.14A50.83,50.83,0,0,0,178.8,280.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.75,287.78a49.73,49.73,0,0,0,5.41.15,50,50,0,0,0,5.42-.15,51.74,51.74,0,0,0-5.42-.14A51.46,51.46,0,0,0,178.75,287.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.8,
    y: 300.45,
    width: 10.74,
    height: 20.7,
    transform: "translate(368.35 621.6) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.87,321.15c.08,0,.14-4.64.14-10.35s-.06-10.35-.14-10.35-.14,4.63-.14,10.35S183.79,321.15,183.87,321.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.8,307.64a50.83,50.83,0,0,0,5.37.14,50.67,50.67,0,0,0,5.37-.14,50.67,50.67,0,0,0-5.37-.14A50.83,50.83,0,0,0,178.8,307.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.75,315a49.73,49.73,0,0,0,5.41.15,50,50,0,0,0,5.42-.15,51.74,51.74,0,0,0-5.42-.14A51.46,51.46,0,0,0,178.75,315Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.8,
    y: 327.71,
    width: 10.74,
    height: 20.7,
    transform: "translate(368.35 676.12) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.87,348.41c.08,0,.14-4.64.14-10.35s-.06-10.35-.14-10.35-.14,4.63-.14,10.35S183.79,348.41,183.87,348.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.8,334.9a50.83,50.83,0,0,0,5.37.14,50.67,50.67,0,0,0,5.37-.14,50.67,50.67,0,0,0-5.37-.14A50.83,50.83,0,0,0,178.8,334.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.75,342.3a49.73,49.73,0,0,0,5.41.15,50,50,0,0,0,5.42-.15,51.74,51.74,0,0,0-5.42-.14A51.46,51.46,0,0,0,178.75,342.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.8,
    y: 354.97,
    width: 10.74,
    height: 20.7,
    transform: "translate(368.35 730.64) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.87,375.67c.08,0,.14-4.64.14-10.35S184,355,183.87,355s-.14,4.63-.14,10.35S183.79,375.67,183.87,375.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.8,362.16a50.83,50.83,0,0,0,5.37.14,50.67,50.67,0,0,0,5.37-.14,50.67,50.67,0,0,0-5.37-.14A50.83,50.83,0,0,0,178.8,362.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.75,369.56a49.73,49.73,0,0,0,5.41.15,50,50,0,0,0,5.42-.15,51.74,51.74,0,0,0-5.42-.14A51.46,51.46,0,0,0,178.75,369.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.83,
    y: 381.34,
    width: 10.74,
    height: 20.7,
    transform: "translate(420.41 783.38) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.9,402c.08,0,.15-4.63.15-10.35s-.07-10.35-.15-10.35-.14,4.63-.14,10.35S209.82,402,209.9,402Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.83,388.53a49.12,49.12,0,0,0,5.37.15,49.23,49.23,0,0,0,5.38-.15,51,51,0,0,0-5.38-.14A50.83,50.83,0,0,0,204.83,388.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.78,395.93a49.73,49.73,0,0,0,5.41.15,50,50,0,0,0,5.42-.15c0-.07-2.43-.14-5.42-.14S204.78,395.86,204.78,395.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.8,
    y: 382.23,
    width: 10.74,
    height: 20.7,
    transform: "translate(368.35 785.16) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.87,402.93c.08,0,.14-4.64.14-10.35s-.06-10.35-.14-10.35-.14,4.63-.14,10.35S183.79,402.93,183.87,402.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.8,389.42a50.83,50.83,0,0,0,5.37.14,50.67,50.67,0,0,0,5.37-.14,50.67,50.67,0,0,0-5.37-.14A50.83,50.83,0,0,0,178.8,389.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.75,396.82a49.73,49.73,0,0,0,5.41.15,50,50,0,0,0,5.42-.15,51.74,51.74,0,0,0-5.42-.14A51.46,51.46,0,0,0,178.75,396.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.57,
    y: 284.27,
    width: 45.88,
    height: 194,
    transform: "translate(327.02 762.55) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.96,
    y: 297.87,
    width: 13.94,
    height: 26.87,
    transform: "translate(341.85 622.62) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.53,324.74c.11,0,.19-6,.19-13.43s-.08-13.44-.19-13.44-.18,6-.18,13.44S170.43,324.74,170.53,324.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,307.21a67.42,67.42,0,0,0,7,.18,67.42,67.42,0,0,0,7-.18,62.57,62.57,0,0,0-7-.19A62.57,62.57,0,0,0,164,307.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.88,316.82a68.64,68.64,0,0,0,7,.18,68.64,68.64,0,0,0,7-.18,63.7,63.7,0,0,0-7-.19A63.7,63.7,0,0,0,163.88,316.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.96,
    y: 332.97,
    width: 13.94,
    height: 26.87,
    transform: "translate(341.85 692.81) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.53,359.84c.11,0,.19-6,.19-13.43s-.08-13.44-.19-13.44-.18,6-.18,13.44S170.43,359.84,170.53,359.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,342.3a62.57,62.57,0,0,0,7,.19,62.57,62.57,0,0,0,7-.19,67.42,67.42,0,0,0-7-.18A67.42,67.42,0,0,0,164,342.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.88,351.91a63.7,63.7,0,0,0,7,.19,63.7,63.7,0,0,0,7-.19,68.64,68.64,0,0,0-7-.18A68.64,68.64,0,0,0,163.88,351.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.96,
    y: 368.07,
    width: 13.94,
    height: 26.87,
    transform: "translate(341.85 763) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.53,394.94c.11,0,.19-6,.19-13.44s-.08-13.43-.19-13.43-.18,6-.18,13.43S170.43,394.94,170.53,394.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,377.4a65.62,65.62,0,0,0,7,.19,65.62,65.62,0,0,0,7-.19,67.42,67.42,0,0,0-7-.18A67.42,67.42,0,0,0,164,377.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.88,387a66.8,66.8,0,0,0,7,.19,66.8,66.8,0,0,0,7-.19,66.8,66.8,0,0,0-7-.19A66.8,66.8,0,0,0,163.88,387Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.96,
    y: 403.16,
    width: 13.94,
    height: 26.87,
    transform: "translate(341.85 833.2) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.53,430c.11,0,.19-6,.19-13.43s-.08-13.44-.19-13.44-.18,6-.18,13.44S170.43,430,170.53,430Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,412.5a65.62,65.62,0,0,0,7,.19,65.62,65.62,0,0,0,7-.19,65.62,65.62,0,0,0-7-.19A65.62,65.62,0,0,0,164,412.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.88,422.11a68.64,68.64,0,0,0,7,.18,68.64,68.64,0,0,0,7-.18,66.8,66.8,0,0,0-7-.19A66.8,66.8,0,0,0,163.88,422.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.06,
    y: 284.27,
    width: 33.43,
    height: 194,
    transform: "translate(275.55 762.55) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.17,
    y: 297.87,
    width: 13.94,
    height: 26.87,
    transform: "translate(274.28 622.62) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.74,324.74c.11,0,.19-6,.19-13.43s-.08-13.44-.19-13.44-.18,6-.18,13.44S136.64,324.74,136.74,324.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.17,307.21a67.42,67.42,0,0,0,7,.18,67.42,67.42,0,0,0,7-.18,62.57,62.57,0,0,0-7-.19A62.57,62.57,0,0,0,130.17,307.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.09,316.82a68.64,68.64,0,0,0,7,.18,68.64,68.64,0,0,0,7-.18,63.7,63.7,0,0,0-7-.19A63.7,63.7,0,0,0,130.09,316.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.17,
    y: 333.26,
    width: 13.94,
    height: 26.87,
    transform: "translate(274.28 693.39) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.74,360.13c.11,0,.19-6,.19-13.44s-.08-13.43-.19-13.43-.18,6-.18,13.43S136.64,360.13,136.74,360.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.17,342.59a62.57,62.57,0,0,0,7,.19,62.57,62.57,0,0,0,7-.19,67.42,67.42,0,0,0-7-.18A67.42,67.42,0,0,0,130.17,342.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.09,352.2a63.7,63.7,0,0,0,7,.19,63.7,63.7,0,0,0,7-.19,68.64,68.64,0,0,0-7-.18A68.64,68.64,0,0,0,130.09,352.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.17,
    y: 368.64,
    width: 13.94,
    height: 26.87,
    transform: "translate(274.28 764.15) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.74,395.51c.11,0,.19-6,.19-13.43s-.08-13.44-.19-13.44-.18,6-.18,13.44S136.64,395.51,136.74,395.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.17,378a67.42,67.42,0,0,0,7,.18,67.42,67.42,0,0,0,7-.18,62.57,62.57,0,0,0-7-.19A62.57,62.57,0,0,0,130.17,378Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.09,387.59a68.64,68.64,0,0,0,7,.18,68.64,68.64,0,0,0,7-.18,63.7,63.7,0,0,0-7-.19A63.7,63.7,0,0,0,130.09,387.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.17,
    y: 404.03,
    width: 13.94,
    height: 26.87,
    transform: "translate(274.28 834.92) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.74,430.9c.11,0,.19-6,.19-13.44s-.08-13.43-.19-13.43-.18,6-.18,13.43S136.64,430.9,136.74,430.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.17,413.36a62.57,62.57,0,0,0,7,.19,62.57,62.57,0,0,0,7-.19,67.42,67.42,0,0,0-7-.18A67.42,67.42,0,0,0,130.17,413.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.09,423a63.7,63.7,0,0,0,7,.19,63.7,63.7,0,0,0,7-.19,68.64,68.64,0,0,0-7-.18A68.64,68.64,0,0,0,130.09,423Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.96,
    y: 438.26,
    width: 13.94,
    height: 26.87,
    transform: "translate(341.85 903.39) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.53,465.13c.11,0,.19-6,.19-13.43s-.08-13.44-.19-13.44-.18,6-.18,13.44S170.43,465.13,170.53,465.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,447.6a67.42,67.42,0,0,0,7,.18,67.42,67.42,0,0,0,7-.18,62.57,62.57,0,0,0-7-.19A62.57,62.57,0,0,0,164,447.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.88,457.21a68.64,68.64,0,0,0,7,.18,68.64,68.64,0,0,0,7-.18,63.7,63.7,0,0,0-7-.19A63.7,63.7,0,0,0,163.88,457.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.17,
    y: 439.41,
    width: 13.94,
    height: 26.87,
    transform: "translate(274.28 905.69) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.74,466.28c.11,0,.19-6,.19-13.43s-.08-13.44-.19-13.44-.18,6-.18,13.44S136.64,466.28,136.74,466.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.17,448.75a67.42,67.42,0,0,0,7,.18,67.42,67.42,0,0,0,7-.18,62.57,62.57,0,0,0-7-.19A62.57,62.57,0,0,0,130.17,448.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.09,458.36a68.64,68.64,0,0,0,7,.18,68.64,68.64,0,0,0,7-.18,63.7,63.7,0,0,0-7-.19A63.7,63.7,0,0,0,130.09,458.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.57,
    y: 208.98,
    width: 45.88,
    height: 188.28,
    transform: "translate(327.02 606.24) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.96,
    y: 222.58,
    width: 13.94,
    height: 26.87,
    transform: "translate(341.85 472.03) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.53,249.45c.11,0,.19-6,.19-13.43s-.08-13.44-.19-13.44-.18,6-.18,13.44S170.43,249.45,170.53,249.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,231.91a62.57,62.57,0,0,0,7,.19,62.57,62.57,0,0,0,7-.19,67.42,67.42,0,0,0-7-.18A67.42,67.42,0,0,0,164,231.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.88,241.52a63.7,63.7,0,0,0,7,.19,63.7,63.7,0,0,0,7-.19,68.64,68.64,0,0,0-7-.18A68.64,68.64,0,0,0,163.88,241.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.96,
    y: 257.68,
    width: 13.94,
    height: 26.87,
    transform: "translate(341.85 542.22) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.53,284.55c.11,0,.19-6,.19-13.44s-.08-13.43-.19-13.43-.18,6-.18,13.43S170.43,284.55,170.53,284.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,267a62.57,62.57,0,0,0,7,.19,62.57,62.57,0,0,0,7-.19,67.42,67.42,0,0,0-7-.18A67.42,67.42,0,0,0,164,267Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.88,276.62a66.8,66.8,0,0,0,7,.19,66.8,66.8,0,0,0,7-.19,68.64,68.64,0,0,0-7-.18A68.64,68.64,0,0,0,163.88,276.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.96,
    y: 292.77,
    width: 13.94,
    height: 26.87,
    transform: "translate(341.85 612.42) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.53,319.64c.11,0,.19-6,.19-13.43s-.08-13.44-.19-13.44-.18,6-.18,13.44S170.43,319.64,170.53,319.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,302.11a65.62,65.62,0,0,0,7,.19,65.62,65.62,0,0,0,7-.19,65.62,65.62,0,0,0-7-.19A65.62,65.62,0,0,0,164,302.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.88,311.72a68.64,68.64,0,0,0,7,.18,68.64,68.64,0,0,0,7-.18,66.8,66.8,0,0,0-7-.19A66.8,66.8,0,0,0,163.88,311.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.96,
    y: 327.87,
    width: 13.94,
    height: 26.87,
    transform: "translate(341.85 682.61) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.53,354.74c.11,0,.19-6,.19-13.43s-.08-13.44-.19-13.44-.18,6-.18,13.44S170.43,354.74,170.53,354.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,337.21a67.42,67.42,0,0,0,7,.18,67.42,67.42,0,0,0,7-.18,62.57,62.57,0,0,0-7-.19A62.57,62.57,0,0,0,164,337.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.88,346.82a68.64,68.64,0,0,0,7,.18,68.64,68.64,0,0,0,7-.18,63.7,63.7,0,0,0-7-.19A63.7,63.7,0,0,0,163.88,346.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.06,
    y: 208.98,
    width: 33.43,
    height: 188.28,
    transform: "translate(275.55 606.24) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.17,
    y: 222.58,
    width: 13.94,
    height: 26.87,
    transform: "translate(274.28 472.03) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.74,249.45c.11,0,.19-6,.19-13.43s-.08-13.44-.19-13.44-.18,6-.18,13.44S136.64,249.45,136.74,249.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.17,231.91a62.57,62.57,0,0,0,7,.19,62.57,62.57,0,0,0,7-.19,67.42,67.42,0,0,0-7-.18A67.42,67.42,0,0,0,130.17,231.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.09,241.52a63.7,63.7,0,0,0,7,.19,63.7,63.7,0,0,0,7-.19,68.64,68.64,0,0,0-7-.18A68.64,68.64,0,0,0,130.09,241.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.17,
    y: 257.97,
    width: 13.94,
    height: 26.87,
    transform: "translate(274.28 542.8) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.74,284.83c.11,0,.19-6,.19-13.43s-.08-13.43-.19-13.43-.18,6-.18,13.43S136.64,284.83,136.74,284.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.17,267.3a65.62,65.62,0,0,0,7,.19,65.62,65.62,0,0,0,7-.19,65.62,65.62,0,0,0-7-.19A65.62,65.62,0,0,0,130.17,267.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.09,276.91a66.8,66.8,0,0,0,7,.19,66.8,66.8,0,0,0,7-.19,66.8,66.8,0,0,0-7-.19A66.8,66.8,0,0,0,130.09,276.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.17,
    y: 293.35,
    width: 13.94,
    height: 26.87,
    transform: "translate(274.28 613.57) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.74,320.22c.11,0,.19-6,.19-13.43s-.08-13.44-.19-13.44-.18,6-.18,13.44S136.64,320.22,136.74,320.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.17,302.68a62.57,62.57,0,0,0,7,.19,62.57,62.57,0,0,0,7-.19,67.42,67.42,0,0,0-7-.18A67.42,67.42,0,0,0,130.17,302.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.09,312.29a63.7,63.7,0,0,0,7,.19,63.7,63.7,0,0,0,7-.19,68.64,68.64,0,0,0-7-.18A68.64,68.64,0,0,0,130.09,312.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.17,
    y: 328.74,
    width: 13.94,
    height: 26.87,
    transform: "translate(274.28 684.34) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.74,355.6c.11,0,.19-6,.19-13.43s-.08-13.43-.19-13.43-.18,6-.18,13.43S136.64,355.6,136.74,355.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.17,338.07a65.62,65.62,0,0,0,7,.19,65.62,65.62,0,0,0,7-.19,65.62,65.62,0,0,0-7-.19A65.62,65.62,0,0,0,130.17,338.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.09,347.68a66.8,66.8,0,0,0,7,.19,66.8,66.8,0,0,0,7-.19,66.8,66.8,0,0,0-7-.19A66.8,66.8,0,0,0,130.09,347.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.96,
    y: 362.97,
    width: 13.94,
    height: 26.87,
    transform: "translate(341.85 752.81) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.53,389.84c.11,0,.19-6,.19-13.44s-.08-13.43-.19-13.43-.18,6-.18,13.43S170.43,389.84,170.53,389.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,372.3a62.57,62.57,0,0,0,7,.19,62.57,62.57,0,0,0,7-.19,67.42,67.42,0,0,0-7-.18A67.42,67.42,0,0,0,164,372.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.88,381.91a63.7,63.7,0,0,0,7,.19,63.7,63.7,0,0,0,7-.19,68.64,68.64,0,0,0-7-.18A68.64,68.64,0,0,0,163.88,381.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.17,
    y: 364.12,
    width: 13.94,
    height: 26.87,
    transform: "translate(274.28 755.11) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.74,391c.11,0,.19-6,.19-13.43s-.08-13.44-.19-13.44-.18,6-.18,13.44S136.64,391,136.74,391Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.17,373.45a62.57,62.57,0,0,0,7,.19,62.57,62.57,0,0,0,7-.19,67.42,67.42,0,0,0-7-.18A67.42,67.42,0,0,0,130.17,373.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.09,383.06a63.7,63.7,0,0,0,7,.19,63.7,63.7,0,0,0,7-.19,68.64,68.64,0,0,0-7-.18A68.64,68.64,0,0,0,130.09,383.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.15,
    y: 306.54,
    width: 40.66,
    height: 171.95,
    transform: "translate(230.97 785.04) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.88,
    y: 318.6,
    width: 12.36,
    height: 23.82,
    transform: "translate(244.11 661.01) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.71,342.41c.09,0,.16-5.33.16-11.9s-.07-11.91-.16-11.91-.17,5.33-.17,11.91S121.62,342.41,121.71,342.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.88,326.87a57.4,57.4,0,0,0,6.18.17,57.55,57.55,0,0,0,6.18-.17,59.32,59.32,0,0,0-6.18-.16A59.16,59.16,0,0,0,115.88,326.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.81,335.39a60.24,60.24,0,0,0,6.23.16,60.24,60.24,0,0,0,6.23-.16,58.45,58.45,0,0,0-6.23-.17A58.45,58.45,0,0,0,115.81,335.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.88,
    y: 349.7,
    width: 12.36,
    height: 23.82,
    transform: "translate(244.11 723.23) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.71,373.52c.09,0,.16-5.33.16-11.91s-.07-11.91-.16-11.91-.17,5.34-.17,11.91S121.62,373.52,121.71,373.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.88,358a59.16,59.16,0,0,0,6.18.16,59.32,59.32,0,0,0,6.18-.16,57.55,57.55,0,0,0-6.18-.17A57.4,57.4,0,0,0,115.88,358Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.81,366.5a60.24,60.24,0,0,0,6.23.16,60.24,60.24,0,0,0,6.23-.16,55.44,55.44,0,0,0-6.23-.17A55.44,55.44,0,0,0,115.81,366.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.88,
    y: 380.81,
    width: 12.36,
    height: 23.82,
    transform: "translate(244.11 785.44) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.71,404.63c.09,0,.16-5.33.16-11.91s-.07-11.91-.16-11.91-.17,5.33-.17,11.91S121.62,404.63,121.71,404.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.88,389.09a59.16,59.16,0,0,0,6.18.16,59.32,59.32,0,0,0,6.18-.16,57.55,57.55,0,0,0-6.18-.17A57.4,57.4,0,0,0,115.88,389.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.81,397.6a58.45,58.45,0,0,0,6.23.17,58.45,58.45,0,0,0,6.23-.17,60.24,60.24,0,0,0-6.23-.16A60.24,60.24,0,0,0,115.81,397.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.88,
    y: 411.92,
    width: 12.36,
    height: 23.82,
    transform: "translate(244.11 847.66) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.71,435.74c.09,0,.16-5.34.16-11.91s-.07-11.91-.16-11.91-.17,5.33-.17,11.91S121.62,435.74,121.71,435.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.88,420.19a54.44,54.44,0,0,0,6.18.17,54.59,54.59,0,0,0,6.18-.17,59.32,59.32,0,0,0-6.18-.16A59.16,59.16,0,0,0,115.88,420.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.81,428.71a58.45,58.45,0,0,0,6.23.17,58.45,58.45,0,0,0,6.23-.17,60.24,60.24,0,0,0-6.23-.16A60.24,60.24,0,0,0,115.81,428.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.86,
    y: 306.54,
    width: 29.63,
    height: 171.95,
    transform: "translate(185.35 785.04) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.93,
    y: 318.6,
    width: 12.36,
    height: 23.82,
    transform: "translate(184.21 661.01) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.76,342.41c.09,0,.16-5.33.16-11.9s-.07-11.91-.16-11.91-.17,5.33-.17,11.91S91.67,342.41,91.76,342.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.93,326.87a57.4,57.4,0,0,0,6.18.17,57.55,57.55,0,0,0,6.18-.17,59.32,59.32,0,0,0-6.18-.16A59.16,59.16,0,0,0,85.93,326.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.86,335.39a60.24,60.24,0,0,0,6.23.16,60.24,60.24,0,0,0,6.23-.16,58.45,58.45,0,0,0-6.23-.17A58.45,58.45,0,0,0,85.86,335.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.93,
    y: 349.96,
    width: 12.36,
    height: 23.82,
    transform: "translate(184.21 723.74) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.76,373.78c.09,0,.16-5.34.16-11.91S91.85,350,91.76,350s-.17,5.33-.17,11.91S91.67,373.78,91.76,373.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.93,358.23a54.44,54.44,0,0,0,6.18.17,54.59,54.59,0,0,0,6.18-.17,59.32,59.32,0,0,0-6.18-.16A59.16,59.16,0,0,0,85.93,358.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.86,366.75a58.45,58.45,0,0,0,6.23.17,58.45,58.45,0,0,0,6.23-.17,60.24,60.24,0,0,0-6.23-.16A60.24,60.24,0,0,0,85.86,366.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.93,
    y: 381.32,
    width: 12.36,
    height: 23.82,
    transform: "translate(184.21 786.46) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.76,405.14c.09,0,.16-5.33.16-11.91s-.07-11.91-.16-11.91-.17,5.33-.17,11.91S91.67,405.14,91.76,405.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.93,389.6a59.16,59.16,0,0,0,6.18.16,59.32,59.32,0,0,0,6.18-.16,57.55,57.55,0,0,0-6.18-.17A57.4,57.4,0,0,0,85.93,389.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.86,398.11a55.44,55.44,0,0,0,6.23.17,55.44,55.44,0,0,0,6.23-.17,60.24,60.24,0,0,0-6.23-.16A60.24,60.24,0,0,0,85.86,398.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.93,
    y: 412.69,
    width: 12.36,
    height: 23.82,
    transform: "translate(184.21 849.19) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.76,436.5c.09,0,.16-5.33.16-11.91s-.07-11.9-.16-11.9-.17,5.33-.17,11.9S91.67,436.5,91.76,436.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.93,421a57.4,57.4,0,0,0,6.18.17,57.55,57.55,0,0,0,6.18-.17,57.55,57.55,0,0,0-6.18-.17A57.4,57.4,0,0,0,85.93,421Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.86,429.48a60.24,60.24,0,0,0,6.23.16,60.24,60.24,0,0,0,6.23-.16,58.45,58.45,0,0,0-6.23-.17A58.45,58.45,0,0,0,85.86,429.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.88,
    y: 443.03,
    width: 12.36,
    height: 23.82,
    transform: "translate(244.11 909.87) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.71,466.84c.09,0,.16-5.33.16-11.9S121.8,443,121.71,443s-.17,5.33-.17,11.91S121.62,466.84,121.71,466.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.88,451.3a57.4,57.4,0,0,0,6.18.17,57.55,57.55,0,0,0,6.18-.17,59.32,59.32,0,0,0-6.18-.16A59.16,59.16,0,0,0,115.88,451.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.81,459.82A60.24,60.24,0,0,0,122,460a60.24,60.24,0,0,0,6.23-.16,58.45,58.45,0,0,0-6.23-.17A58.45,58.45,0,0,0,115.81,459.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.93,
    y: 444.05,
    width: 12.36,
    height: 23.82,
    transform: "translate(184.21 911.91) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.76,467.86c.09,0,.16-5.33.16-11.9s-.07-11.91-.16-11.91-.17,5.33-.17,11.91S91.67,467.86,91.76,467.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.93,452.32a57.4,57.4,0,0,0,6.18.17,57.55,57.55,0,0,0,6.18-.17,59.32,59.32,0,0,0-6.18-.16A59.16,59.16,0,0,0,85.93,452.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.86,460.84a60.24,60.24,0,0,0,6.23.16,60.24,60.24,0,0,0,6.23-.16,58.45,58.45,0,0,0-6.23-.17A58.45,58.45,0,0,0,85.86,460.84Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M482.28,478.49c0,.15-104,.26-232.27.26s-232.29-.11-232.29-.26,104-.26,232.29-.26S482.28,478.35,482.28,478.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "403.38 468.46 398.13 472.39 382.96 458.92 373.63 464.3 351.77 446.16 350.75 445.31 362.35 478.49 423.68 478.49 403.38 468.46",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.39 478.49 328.96 388.11 332.34 356.27 228.88 361.42 148.73 398.76 76.31 478.49 363.39 478.49",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.39,478.49l-287.08.26h-.58l.39-.43L123.64,426l24.9-27.41,0,0,.05,0,80.16-37.32,0,0h.05l103.46-5.1h.23l0,.23c-1.22,11.38-2.35,21.95-3.4,31.84v-.08c21.32,56.3,33.77,89.16,34.26,90.44l-34.6-90.32v-.08c1.05-9.89,2.16-20.46,3.36-31.84l.21.22L228.9,361.66l.09,0L148.84,399l.08-.06L124,426.35,76.5,478.67l-.19-.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.33,472.54a1.61,1.61,0,0,1,.14-.31l.45-.9,1.79-3.43,6.66-12.57L261.51,414l5.65-10.5,0-.09.1,0c14.88-4.32,28-8.06,37.36-10.66,4.69-1.3,8.45-2.32,11.06-3a20.77,20.77,0,0,1,4-.87s-.08,0-.26.05l-.78.19-3,.8-11,3.13-37.31,10.83.16-.12L262,414.21l-22.28,41.3L232.89,468,231,471.38l-.5.87C230.4,472.45,230.34,472.55,230.33,472.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.25 467.86 159.57 423.1 146.91 434.57 132.49 412.5 126.43 419.19 115.42 396.96 105.89 408.95 68.57 372.12 54.23 387.74 45.49 378.14 22.79 398 21.14 478.49 226.73 478.49 193.25 467.86",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.57,422.07a4.92,4.92,0,0,1-.5-1.06l-1.22-2.92c-1-2.46-2.59-5.81-4.52-9.4l-.73-1.32a2.77,2.77,0,0,0-.36-.58,1.57,1.57,0,0,0-.51-.36,2.19,2.19,0,0,0-2.32.29c-1,1.35-1.9,2.73-2.63,3.83l-1.7,2.67a5.83,5.83,0,0,1-.67,1,4.63,4.63,0,0,1,.49-1.06c.35-.66.88-1.61,1.57-2.76s1.51-2.48,2.6-4a2.63,2.63,0,0,1,2.87-.41,2,2,0,0,1,.68.47,2.88,2.88,0,0,1,.43.67l.74,1.33a87.53,87.53,0,0,1,4.4,9.51c.48,1.25.84,2.28,1.07,3A5.42,5.42,0,0,1,68.57,422.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,422.92a28.85,28.85,0,0,1-1.28-2.8c-.4-.86-.93-1.85-1.56-2.93l-1-1.71a7.19,7.19,0,0,0-.51-.83,1.34,1.34,0,0,0-.81-.35,1.59,1.59,0,0,0-.9.14.92.92,0,0,0-.32.25c-.09.11-.2.28-.29.41l-1.11,1.63-1.82,2.8a22.35,22.35,0,0,1-1.75,2.54,16.4,16.4,0,0,1,1.44-2.74c.47-.82,1.06-1.79,1.73-2.86.34-.53.7-1.09,1.09-1.66.1-.14.18-.28.3-.44a1.41,1.41,0,0,1,.49-.39,2.09,2.09,0,0,1,1.2-.2,1.89,1.89,0,0,1,1.12.51,5,5,0,0,1,.58.94l1,1.72A28.44,28.44,0,0,1,58,420c.36.89.6,1.62.76,2.13S59,422.9,59,422.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.41,414.18a8.18,8.18,0,0,1-.59-1.3c-.37-.95-.85-2.17-1.43-3.62s-1.29-3.39-2-5.4l-.59-1.56a1.7,1.7,0,0,0-1-1,1.73,1.73,0,0,0-2.06.77l-.46.8a127.37,127.37,0,0,0-5.3,11.67c-.64,1.51-1.17,2.73-1.57,3.56a7.62,7.62,0,0,1-.67,1.27,7.86,7.86,0,0,1,.48-1.35l1.42-3.62a100,100,0,0,1,5.19-11.78c.15-.28.31-.55.46-.82a2.31,2.31,0,0,1,.72-.74,2.25,2.25,0,0,1,2-.24,2.21,2.21,0,0,1,1.35,1.32c.19.54.39,1.06.57,1.57l2,5.44c.51,1.49.94,2.72,1.27,3.69A6.9,6.9,0,0,1,53.41,414.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.15,440.33c-.07,0-.6-1.32-1.52-3.46s-2.27-5.06-3.95-8.19c-.22-.39-.43-.78-.63-1.16a2.61,2.61,0,0,0-.31-.49,1.23,1.23,0,0,0-.44-.3,1.88,1.88,0,0,0-2,.23c-.87,1.18-1.66,2.39-2.29,3.34l-1.5,2.32a3.86,3.86,0,0,1-.59.83,4,4,0,0,1,.42-.93c.3-.58.76-1.41,1.36-2.41s1.3-2.17,2.26-3.48a2.36,2.36,0,0,1,2.55-.37,1.83,1.83,0,0,1,.59.42,2.6,2.6,0,0,1,.39.59l.64,1.16a75.52,75.52,0,0,1,3.83,8.3c.42,1.09.73,2,.93,2.61A4.36,4.36,0,0,1,106.15,440.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.78,441.07a19.45,19.45,0,0,1-1.14-2.43c-.35-.75-.81-1.61-1.37-2.55l-.86-1.49a6.48,6.48,0,0,0-.44-.71,1.13,1.13,0,0,0-.69-.3,1.29,1.29,0,0,0-.76.12.64.64,0,0,0-.27.21c-.08.09-.17.24-.26.35l-1,1.42c-.57.88-1.11,1.7-1.6,2.44a14.38,14.38,0,0,1-1.54,2.2,12.5,12.5,0,0,1,1.23-2.4c.42-.72.92-1.57,1.51-2.5.29-.46.61-.95.94-1.45.09-.12.16-.24.27-.38a1.37,1.37,0,0,1,.44-.36,2,2,0,0,1,1.06-.17,1.7,1.7,0,0,1,1,.45,5.05,5.05,0,0,1,.51.83l.84,1.5A24.11,24.11,0,0,1,97,438.49,10.44,10.44,0,0,1,97.78,441.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.93,433.45a5.76,5.76,0,0,1-.53-1.13l-1.25-3.15-1.8-4.7-.51-1.36a1.47,1.47,0,0,0-.9-.89,1.51,1.51,0,0,0-1.29.17,1.47,1.47,0,0,0-.47.49l-.4.7c-2.08,3.82-3.49,7.53-4.63,10.16-.56,1.33-1,2.39-1.38,3.11a5.5,5.5,0,0,1-.6,1.1,7.15,7.15,0,0,1,.42-1.18c.32-.85.73-1.9,1.22-3.16a85.45,85.45,0,0,1,4.52-10.28l.4-.72a2.12,2.12,0,0,1,.64-.66,2,2,0,0,1,1.73-.21,2,2,0,0,1,1.2,1.18c.17.46.33.92.49,1.37.63,1.76,1.21,3.36,1.7,4.74s.81,2.36,1.11,3.22A5.61,5.61,0,0,1,92.93,433.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.27,469.58c-.07,0-.6-1.32-1.52-3.46s-2.27-5.06-4-8.19c-.21-.39-.43-.77-.63-1.15a2.32,2.32,0,0,0-.31-.49,1.4,1.4,0,0,0-.44-.31,1.88,1.88,0,0,0-2,.24c-.87,1.17-1.66,2.38-2.29,3.34l-1.5,2.32a4.69,4.69,0,0,1-.59.83,4,4,0,0,1,.42-.94c.3-.58.76-1.41,1.36-2.41s1.3-2.16,2.26-3.48a2.34,2.34,0,0,1,2.55-.36,1.69,1.69,0,0,1,.59.42,2.4,2.4,0,0,1,.39.59l.64,1.16A74.64,74.64,0,0,1,58.09,466c.42,1.1.73,2,.93,2.62A4.23,4.23,0,0,1,59.27,469.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.05,462.71a6.19,6.19,0,0,1-.52-1.14c-.34-.84-.76-1.9-1.26-3.15s-1.13-3-1.8-4.7c-.17-.44-.34-.9-.51-1.36a1.45,1.45,0,0,0-.9-.88,1.55,1.55,0,0,0-1.29.16,1.57,1.57,0,0,0-.47.49l-.4.7c-2.08,3.82-3.49,7.54-4.63,10.17-.56,1.32-1,2.38-1.38,3.11a5.19,5.19,0,0,1-.6,1.09,7.29,7.29,0,0,1,.42-1.17c.32-.85.73-1.91,1.22-3.17a86.15,86.15,0,0,1,4.52-10.28l.4-.72a2,2,0,0,1,.64-.65,2,2,0,0,1,2.93,1l.49,1.37c.63,1.76,1.21,3.36,1.7,4.75l1.11,3.21A5.59,5.59,0,0,1,46.05,462.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.81,470.36a36.16,36.16,0,0,1-1.52-3.46c-.92-2.14-2.27-5.06-4-8.19l-.63-1.15a2.72,2.72,0,0,0-.31-.5,1.19,1.19,0,0,0-.43-.3,1.86,1.86,0,0,0-2,.24c-.87,1.17-1.66,2.38-2.29,3.33l-1.5,2.32a4.34,4.34,0,0,1-.59.83,3.69,3.69,0,0,1,.41-.93c.31-.58.76-1.41,1.36-2.41s1.31-2.17,2.27-3.48a2.35,2.35,0,0,1,2.54-.37,1.77,1.77,0,0,1,.6.42,3.31,3.31,0,0,1,.39.59l.63,1.16a74,74,0,0,1,3.84,8.3c.42,1.1.73,2,.92,2.61A4.15,4.15,0,0,1,150.81,470.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.59,463.48a5.76,5.76,0,0,1-.53-1.13l-1.25-3.15c-.53-1.38-1.14-3-1.8-4.7-.17-.45-.34-.9-.52-1.36a1.43,1.43,0,0,0-.9-.88,1.46,1.46,0,0,0-1.28.16,1.47,1.47,0,0,0-.47.49l-.4.7a108.34,108.34,0,0,0-4.63,10.17c-.56,1.32-1,2.38-1.38,3.1a5.14,5.14,0,0,1-.6,1.1,6.73,6.73,0,0,1,.41-1.18l1.23-3.16A85.18,85.18,0,0,1,130,453.36l.41-.72A2.12,2.12,0,0,1,131,452a2,2,0,0,1,1.73-.21A2,2,0,0,1,134,453c.17.46.34.92.5,1.37l1.7,4.75c.44,1.27.81,2.35,1.1,3.21A6.17,6.17,0,0,1,137.59,463.48Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M439.6,431.55a8.58,8.58,0,0,1,4.46,5,15.21,15.21,0,0,1,.59,6.84c-.5,4.43-3,8.91-5.74,12.45-3.73-3.26-4.59-8.94-4.84-11.85-.41-4.61,1.66-13.17,5.53-12.48",
    style: {
      fill: "#AE460C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.25,463.2a7.35,7.35,0,0,1,2.37-7A9.74,9.74,0,0,1,452.8,454,4.13,4.13,0,0,1,456,455.4a3.14,3.14,0,0,1,0,3.18,6.23,6.23,0,0,1-2.35,2.32c-3.23,2-6.74,3.4-10.4,2.3",
    style: {
      fill: "#AE460C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.88,478.18a5.14,5.14,0,0,1,.15-1c.13-.73.3-1.67.51-2.8a29.35,29.35,0,0,1,2.89-9,17.92,17.92,0,0,1,6.43-6.82,12.12,12.12,0,0,1,2.62-1.16,6.28,6.28,0,0,1,.75-.19.8.8,0,0,1,.27,0,18.74,18.74,0,0,0-3.51,1.61,18.46,18.46,0,0,0-6.23,6.78,31.25,31.25,0,0,0-3,8.83c-.26,1.17-.47,2.13-.63,2.78A6.38,6.38,0,0,1,438.88,478.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439,434.26a2.23,2.23,0,0,1,0,.45c0,.34,0,.77.07,1.3.07,1.13.13,2.77.2,4.79.13,4,.23,9.63.2,15.81s-.17,11.76-.34,15.8c-.08,2-.16,3.66-.23,4.79,0,.53-.07,1-.09,1.3a1.76,1.76,0,0,1-.06.45,2.35,2.35,0,0,1,0-.46c0-.33,0-.76,0-1.3,0-1.17.07-2.8.12-4.79.1-4,.21-9.62.24-15.8s0-11.75-.1-15.79c0-2-.06-3.62-.08-4.79,0-.54,0-1,0-1.31A1.79,1.79,0,0,1,439,434.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.79,465.9a17.12,17.12,0,0,0-9.36-12.56c-1.25-.6-2.88-1-3.9-.06s-.8,2.6-.3,3.89a14.64,14.64,0,0,0,13.47,9.09",
    style: {
      fill: "#AE460C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427,456.26a5.17,5.17,0,0,1,.91.4,9.62,9.62,0,0,1,1,.54c.38.24.84.47,1.29.81a18.11,18.11,0,0,1,1.49,1.12,20.24,20.24,0,0,1,1.58,1.44,21.58,21.58,0,0,1,3,3.85,21.29,21.29,0,0,1,2,4.47,16.84,16.84,0,0,1,.5,2.08,14.77,14.77,0,0,1,.26,1.84,14.21,14.21,0,0,1,.07,1.53,8,8,0,0,1,0,1.15,5.49,5.49,0,0,1-.1,1c-.09,0,.06-1.4-.19-3.63a14.81,14.81,0,0,0-.3-1.81,18,18,0,0,0-.52-2,20.68,20.68,0,0,0-4.9-8.19c-.52-.52-1-1-1.53-1.44a18,18,0,0,0-1.44-1.13C428.25,456.92,427,456.33,427,456.26Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 212.28,
    cy: 61.69,
    r: 24.27,
    transform: "translate(18.56 168.17) rotate(-45)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.56,61.69a1.87,1.87,0,0,1-.05-.4c0-.28,0-.66-.08-1.15q0-.37-.06-.84c0-.31-.1-.65-.16-1a18.1,18.1,0,0,0-.51-2.49,23.15,23.15,0,0,0-2.7-6.42,24.18,24.18,0,0,0-6.14-6.83,24.06,24.06,0,0,0-22.77-3.43A26.14,26.14,0,0,0,201,40.49a24.94,24.94,0,0,0-2.94,1.9,27,27,0,0,0-2.73,2.32,27.38,27.38,0,0,0-2.35,2.78,23.13,23.13,0,0,0-3.43,6.62,23.76,23.76,0,0,0,0,15.15,23,23,0,0,0,3.43,6.62,26.26,26.26,0,0,0,2.35,2.79A27,27,0,0,0,198,81,25.32,25.32,0,0,0,201,82.88a26.14,26.14,0,0,0,3.13,1.38,24.23,24.23,0,0,0,12.63,1.06,23.9,23.9,0,0,0,10.14-4.49A24.16,24.16,0,0,0,233,74a23,23,0,0,0,2.7-6.42,18.21,18.21,0,0,0,.51-2.5c.06-.37.13-.7.16-1s0-.59.06-.85c0-.48.06-.87.08-1.15a1.69,1.69,0,0,1,.05-.39,3.81,3.81,0,0,1,0,.39c0,.29,0,.67,0,1.16,0,.25,0,.54,0,.85s-.09.65-.13,1a19.52,19.52,0,0,1-.47,2.53,23.2,23.2,0,0,1-2.65,6.52,24.38,24.38,0,0,1-29.32,10.55,25,25,0,0,1-3.2-1.4,24.66,24.66,0,0,1-3-1.92A28.21,28.21,0,0,1,194.93,79a27.47,27.47,0,0,1-2.4-2.84A23.58,23.58,0,0,1,189,69.43a26.09,26.09,0,0,1-1.26-7.75A25.77,25.77,0,0,1,189,53.94a23.69,23.69,0,0,1,3.51-6.75,26.37,26.37,0,0,1,2.41-2.84A25.71,25.71,0,0,1,197.72,42a26,26,0,0,1,3-1.93,25.67,25.67,0,0,1,3.2-1.4,24.5,24.5,0,0,1,12.87-1,24.46,24.46,0,0,1,16.45,11.59,22.62,22.62,0,0,1,2.64,6.52,16.74,16.74,0,0,1,.47,2.52c0,.37.11.71.14,1s0,.6,0,.86c0,.48,0,.87,0,1.15S236.56,61.69,236.56,61.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.16,59.68a9.88,9.88,0,1,0-14.09,8.93V71.1h8.66s.05-1.4.07-2.64A9.88,9.88,0,0,0,222.16,59.68Z",
    style: {
      fill: "#AE460C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.72,72.7h-8.58a.61.61,0,0,1-.65-.55h0a.61.61,0,0,1,.65-.56h8.58a.61.61,0,0,1,.65.56h0A.61.61,0,0,1,216.72,72.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.06,73.19h-7.43a.56.56,0,0,0,0,1.12h.82l1.08,2a.71.71,0,0,0,.63.39h2.66a.73.73,0,0,0,.64-.39l1-2h.55a.56.56,0,0,0,0-1.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.32,76.53a3.6,3.6,0,0,1-.51-.15,4.14,4.14,0,0,0-2.51.07c-.31.11-.49.2-.5.19a1.22,1.22,0,0,1,.47-.27,3.48,3.48,0,0,1,1.27-.27,3.33,3.33,0,0,1,1.29.2A1.71,1.71,0,0,1,214.32,76.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.52,74.33s-1.34.06-3,.06-3,0-3-.06,1.35-.06,3-.06S215.52,74.3,215.52,74.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.06,75.21a3.65,3.65,0,0,1-.73.08c-.46,0-1.08,0-1.77.06s-1.32,0-1.78,0a3.84,3.84,0,0,1-.73-.06s.28,0,.73,0l1.77,0,1.77,0A4,4,0,0,1,215.06,75.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.65,51.73c0,.1-.68.28-1.66.86a7.74,7.74,0,0,0-3.9,7.37c.07,1.14.31,1.83.22,1.86a3.28,3.28,0,0,1-.67-1.81,7.35,7.35,0,0,1,4.14-7.82A3.28,3.28,0,0,1,209.65,51.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.51,51.2c0,.18-.14.36-.39.4s-.48-.06-.51-.23.14-.35.39-.4S212.48,51,212.51,51.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.73,70.81a3.44,3.44,0,0,1-.06-.35c0-.26-.07-.59-.13-1-.11-.9-.26-2.16-.44-3.71-.09-.78-.21-1.63-.28-2.57a1,1,0,0,1,.25-.69.57.57,0,0,1,.75-.08,1,1,0,0,1,.38.68,1.76,1.76,0,0,1-.1.79A2.1,2.1,0,0,1,214,65a1.89,1.89,0,0,1-1.67-.05,2.4,2.4,0,0,1-1.13-1.33,2,2,0,0,1-.11-.91,1,1,0,0,1,.17-.45.59.59,0,0,1,.44-.24.63.63,0,0,1,.45.2,1.3,1.3,0,0,1,.27.39,2.54,2.54,0,0,1,.16.89,2.17,2.17,0,0,1-.62,1.63,1.56,1.56,0,0,1-1.61.39,2.45,2.45,0,0,1-1.19-1.1,3.82,3.82,0,0,1-.31-.72,1.68,1.68,0,0,1-.08-.77.67.67,0,0,1,.19-.36.35.35,0,0,1,.41,0,1.11,1.11,0,0,1,.35.65,13.54,13.54,0,0,1,.28,6.27,9.49,9.49,0,0,1-.34,1.33s0-.12.08-.35.13-.56.2-1a13.48,13.48,0,0,0-.34-6.22c-.06-.22-.12-.47-.3-.57a.21.21,0,0,0-.26,0,.5.5,0,0,0-.14.28,1.59,1.59,0,0,0,.08.71,4.23,4.23,0,0,0,.3.69,2.31,2.31,0,0,0,1.12,1,1.44,1.44,0,0,0,1.46-.37,2,2,0,0,0,.57-1.51,2.36,2.36,0,0,0-.15-.84c-.11-.25-.32-.5-.58-.5s-.43.29-.46.56a2,2,0,0,0,.1.84,2.26,2.26,0,0,0,1.06,1.25,1.74,1.74,0,0,0,1.54,0A2,2,0,0,0,215,63.83a1.54,1.54,0,0,0,.09-.73.87.87,0,0,0-.32-.59.43.43,0,0,0-.58.06.88.88,0,0,0-.22.61c.06.9.19,1.77.26,2.55.17,1.55.3,2.81.4,3.71l.1,1C214.72,70.68,214.73,70.81,214.73,70.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.54,72.22A3.56,3.56,0,1,1,243,68.66,3.56,3.56,0,0,1,246.54,72.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.54,72.22s0-.32-.21-.84a3.51,3.51,0,0,0-1.3-1.84,3.38,3.38,0,0,0-3.17-.43,3.32,3.32,0,0,0,0,6.23A3.41,3.41,0,0,0,245,74.9a3.51,3.51,0,0,0,1.3-1.84c.16-.52.16-.84.21-.84a1.68,1.68,0,0,1,0,.89,3.53,3.53,0,0,1-1.28,2.08,3.73,3.73,0,0,1-3.56.6,3.78,3.78,0,0,1,0-7.13,3.7,3.7,0,0,1,3.56.59,3.56,3.56,0,0,1,1.28,2.08A1.68,1.68,0,0,1,246.54,72.22Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.36,46.16A4,4,0,0,1,283.5,44a5.5,5.5,0,0,1,6.77,0,4.89,4.89,0,0,1,7.46,3.84,4.09,4.09,0,0,1,3.71,6.81,3.93,3.93,0,0,1-1.5,7.67L280.19,50.73A4,4,0,0,1,279.36,46.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.52,62.88a16.66,16.66,0,0,0-16.92-15l-.86,0c-9.29.74-13.86,9-12.87,18.3l2,31,1.35,3.87,16,20.06,4-18.07.08-8.39s8.91-1.57,8.84-10.52C302.13,79.8,301.34,70.92,300.52,62.88Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.32,94.65a21.61,21.61,0,0,1-11.7-3.21s2.87,6.39,11.69,5.43Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.1,71.61a1.27,1.27,0,0,1-1.2,1.31,1.22,1.22,0,0,1-1.34-1.12,1.28,1.28,0,0,1,1.2-1.32A1.23,1.23,0,0,1,298.1,71.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.8,67.75c-.15.17-1.14-.53-2.51-.5s-2.37.74-2.52.58.08-.38.51-.71a3.48,3.48,0,0,1,2-.66,3.28,3.28,0,0,1,2,.6C298.73,67.37,298.88,67.67,298.8,67.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.65,72.3c-.15.17-1.14-.53-2.51-.5s-2.37.74-2.52.58.08-.38.52-.71a3.42,3.42,0,0,1,2-.66,3.28,3.28,0,0,1,2,.6C285.58,71.92,285.73,72.22,285.65,72.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.39,77.92a8.56,8.56,0,0,1,2.22-.45c.35,0,.68-.12.74-.36a1.86,1.86,0,0,0-.26-1c-.35-.84-.71-1.72-1.09-2.65a46.42,46.42,0,0,1-2.48-6.94c.16-.06,1.51,3,3,6.73.37.93.72,1.81,1.05,2.66a2,2,0,0,1,.21,1.38.86.86,0,0,1-.57.52,2.91,2.91,0,0,1-.59.1A9.66,9.66,0,0,1,290.39,77.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.66,69.13c-.16.36-1.35.06-2.78.12s-2.63.37-2.79,0c-.07-.17.17-.5.67-.81a4.29,4.29,0,0,1,2.12-.61,4.15,4.15,0,0,1,2.12.5C285.49,68.64,285.73,69,285.66,69.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.41,64c-.21.34-1.18.11-2.32.22s-2.07.42-2.32.12c-.11-.15,0-.48.39-.81a3.34,3.34,0,0,1,3.74-.27C298.34,63.52,298.5,63.82,298.41,64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.58,58.8s-2.48-5.55-5.2-6.8c-3.3-1.52-4.64,2.1-7.77,1.29s-6.28-2.26-9.42.22c-3.43,2.7-1.76,4.52-1.89,8.49-.54,16.1-3.38,20.71-4.38,13.15-.1-.83-2.42-1.44-2.83-4.94-.54-4.54-.83-10,.12-13.3.8-2.74,2.31-4.65,5.05-6.78,4.32-3.36,10.35-3.56,14.45-3.23S299.81,51.78,299.58,58.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.49,74.9a2.44,2.44,0,0,0-2.67-2.29c-1.66.19-3.5,1.18-3.32,4.62.32,6.11,6.39,4.53,6.39,4.35S271.65,77.45,271.49,74.9Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.44,79.35s-.1.08-.28.18a1,1,0,0,1-.79,0A2.6,2.6,0,0,1,268,77.29a3.5,3.5,0,0,1,.21-1.54,1.24,1.24,0,0,1,.76-.86.54.54,0,0,1,.64.26c.09.16.06.29.1.3s.12-.11.06-.36a.67.67,0,0,0-.26-.37.84.84,0,0,0-.6-.13,1.51,1.51,0,0,0-1.06,1,3.57,3.57,0,0,0-.28,1.72,2.76,2.76,0,0,0,1.69,2.56,1.13,1.13,0,0,0,1-.22C270.44,79.5,270.46,79.36,270.44,79.35Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.36,63.05A5.74,5.74,0,0,0,274,64.19a2,2,0,0,0,2.18-1.44c.06-.43-.05-.92.22-1.26s.95-.29,1.46-.24a3.91,3.91,0,0,0,4-2.88,1.64,1.64,0,0,0,2.2.16,8.6,8.6,0,0,0,1.63-1.82,2.54,2.54,0,0,1,2.08-1.09,5.71,5.71,0,0,0,1.33.27c.8-.09,1.18-1,1.28-1.84s.18-1.73.85-2.18a3.21,3.21,0,0,1,2.19-.1c.74.09,1.69-.1,1.86-.83a1.43,1.43,0,0,0-.29-1.1,4,4,0,0,0-4.71-1.4,5.37,5.37,0,0,0-9.88-.84,5.44,5.44,0,0,0-8.66,2.16,4,4,0,0,0-4.33,5.84,3.72,3.72,0,0,0-2,3,2.14,2.14,0,0,0,2.47,2.15,2.19,2.19,0,0,0,3.83,2.1",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287,80.17a.53.53,0,0,0-.4-.07.5.5,0,0,0-.24.29,3.08,3.08,0,0,0,.35,3l0,0a2,2,0,0,0,3.45-.45l.48-1Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.88,83.43c.05,0-.41.63-1.52.76a1.73,1.73,0,0,1-.9-.15,1.93,1.93,0,0,1-.85-.61,3.67,3.67,0,0,1-.6-2.23,4.4,4.4,0,0,1,0-.62.91.91,0,0,1,.37-.62.73.73,0,0,1,.7,0l.47.24,1.62.84a8.19,8.19,0,0,1,1.44.86,6.57,6.57,0,0,1-1.57-.61l-1.65-.76c-.3-.13-.69-.38-.81-.27s-.21.53-.21.9a3.5,3.5,0,0,0,.5,2,1.78,1.78,0,0,0,.69.53,1.47,1.47,0,0,0,.75.17A3.75,3.75,0,0,0,289.88,83.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.4,60.76a1.48,1.48,0,0,0,.41,1.17,2,2,0,0,0,1.24.71,2.11,2.11,0,0,0,1.73-.55l-.26,0a6.44,6.44,0,0,0,1.25,1.5,3.52,3.52,0,0,0,1.13.67,2.72,2.72,0,0,0,3-1,3.69,3.69,0,0,0,.47-1.28,1.29,1.29,0,0,0,0-.5,2.49,2.49,0,0,0-.17.46,3.92,3.92,0,0,1-.54,1.18,2.49,2.49,0,0,1-3.67.16,6.16,6.16,0,0,1-1.19-1.4l-.11-.18-.15.14a1.87,1.87,0,0,1-1.47.5,1.82,1.82,0,0,1-1.11-.56A3,3,0,0,1,267.4,60.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.67,46.56s.16,0,.43.15a2.21,2.21,0,0,1,1,.79l.07.12.09-.12a7.54,7.54,0,0,1,2.9-2.45,6,6,0,0,1,2.4-.58,5.07,5.07,0,0,1,4.17,2.12,4,4,0,0,1,.71,1.82l0,.2.18-.06a3.45,3.45,0,0,1,2.55.26,3.35,3.35,0,0,1,1.42,1.46,4.92,4.92,0,0,1,.42,1.8,1.27,1.27,0,0,0,.06-.5,3.37,3.37,0,0,0-.3-1.38,3.5,3.5,0,0,0-1.47-1.62,3.7,3.7,0,0,0-2.77-.33l.21.14a4.58,4.58,0,0,0-.75-2,5.41,5.41,0,0,0-1.68-1.54,5.24,5.24,0,0,0-2.79-.72,6.17,6.17,0,0,0-2.52.64,7.45,7.45,0,0,0-2.93,2.62h.16a2.14,2.14,0,0,0-1.09-.77A1,1,0,0,0,278.67,46.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.79,332.7l.13,17.2s17.52,5.65,17.86,8.83l-33.34,1.44-1.3-26.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.55,348.9a1.38,1.38,0,0,0-.88,1.6,1.33,1.33,0,0,0,1.58.88,1.43,1.43,0,0,0,.91-1.7,1.35,1.35,0,0,0-1.73-.73",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.44,360.17l0-2.71,32-.37s1.51.58,1.39,1.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.45,349.71c0,.16-.81.27-1.59.83s-1.17,1.26-1.32,1.2,0-1,1-1.67S299.48,349.56,299.45,349.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303,351c.05.16-.65.47-1.17,1.18s-.65,1.45-.81,1.45-.31-.92.36-1.79S303,350.85,303,351Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.18,355.1c-.15,0-.41-.76,0-1.67s1.13-1.3,1.2-1.16-.38.63-.68,1.38S305.34,355.08,305.18,355.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299,345.79c-.06.15-.82,0-1.74.06s-1.62.43-1.71.29.57-.75,1.66-.85S299.06,345.66,299,345.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.13,336.36l-1.8,20.73,3.3,16.81a2.14,2.14,0,0,1-1.83,2.53h0a2.13,2.13,0,0,1-1.83-.67c-3-3.24-13.86-15.23-13.64-16.74.25-1.74.45-22,.45-22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.8,376.43l-15.38-18.81-.06.88a3.19,3.19,0,0,0,.63,2.13c1.22,1.63,4.68,6.07,12.91,15.13a2.15,2.15,0,0,0,1.9.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.11,351.2a1.29,1.29,0,0,1,.25,1.7,1.25,1.25,0,0,1-1.69.26,1.36,1.36,0,0,1-.25-1.81,1.29,1.29,0,0,1,1.78-.07",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M255.64,367.05a6.58,6.58,0,0,1,1.92-1.5,6.39,6.39,0,0,1,2.42-.3c0-.05-.23-.23-.71-.33a3.31,3.31,0,0,0-1.88.21,3.28,3.28,0,0,0-1.48,1.18C255.64,366.73,255.59,367,255.64,367.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.94,369.93a15.54,15.54,0,0,1,1.89-.78,18.93,18.93,0,0,1,2.05-.13,2.36,2.36,0,0,0-2.15-.31C257.49,369,256.83,369.86,256.94,369.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.11,363.31a20.83,20.83,0,0,1,2.85-1.39,19.58,19.58,0,0,1,3.12-.52,5.81,5.81,0,0,0-6,1.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.13,357c.05.13,1.23-.28,2.73-.23s2.65.47,2.71.35a5.31,5.31,0,0,0-5.44-.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.51,350.86a11,11,0,0,1,2.83-.32,10.55,10.55,0,0,1,2.71.87s-.18-.32-.64-.62a4.62,4.62,0,0,0-4.15-.41C253.74,350.59,253.48,350.82,253.51,350.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.38,349.38a1.86,1.86,0,0,0,.07-.78,5.38,5.38,0,0,0-.49-2.1,2.42,2.42,0,0,0-1-1.22.86.86,0,0,0-1,.13,1.39,1.39,0,0,0-.39.91,3,3,0,0,0,2.46,2.95,3.48,3.48,0,0,0,3.54-1.6,1.24,1.24,0,0,0,.13-1,.83.83,0,0,0-.85-.5,3,3,0,0,0-1.42.62,6.15,6.15,0,0,0-1.52,1.52c-.28.42-.39.69-.36.7a9.67,9.67,0,0,1,2.06-1.95,2.88,2.88,0,0,1,1.25-.52.44.44,0,0,1,.46.27.83.83,0,0,1-.12.66,3.12,3.12,0,0,1-3.08,1.36,2.63,2.63,0,0,1-2.13-2.48,1,1,0,0,1,.25-.65.47.47,0,0,1,.54-.08,2.21,2.21,0,0,1,.83,1A8.31,8.31,0,0,1,256.38,349.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.42,190.12A74.09,74.09,0,0,1,318,211.86c-.36,4.61-15.94,132.37-15.94,132.37h-21L287,224.16l-1.72.37s-11.49,51.21-12.43,59.5c-.84,7.46-11.15,66-11.15,66l-19.85-.22,7.38-75.62,7.15-68.71,2.69-20Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.65,211.91a5.09,5.09,0,0,0,.88.49,9.63,9.63,0,0,0,2.61.91,5.41,5.41,0,0,0,1.93,0,4,4,0,0,0,2-1,4.68,4.68,0,0,0,1.23-2.14,25.38,25.38,0,0,0,.56-2.54c.68-3.46,1.13-6.63,1.39-8.92.14-1.15.23-2.08.27-2.73a4.24,4.24,0,0,0,0-1,4.34,4.34,0,0,0-.2,1c-.11.73-.25,1.64-.41,2.71-.34,2.28-.84,5.42-1.51,8.88-.34,1.71-.57,3.45-1.64,4.47a4.36,4.36,0,0,1-3.63.94,11.21,11.21,0,0,1-2.59-.76A4.75,4.75,0,0,0,283.65,211.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290,195.62s-.14-.11-.44-.13a1.88,1.88,0,0,0-1.17.38,2.09,2.09,0,0,0-.89,1.63,2.09,2.09,0,0,0,3.55,1.33,2.07,2.07,0,0,0,.4-1.81,1.85,1.85,0,0,0-.64-1.06.69.69,0,0,0-.41-.19,2.33,2.33,0,0,1,.74,1.31,1.82,1.82,0,0,1-.4,1.48,1.7,1.7,0,0,1-2.83-1.07,1.85,1.85,0,0,1,.67-1.37A2.39,2.39,0,0,1,290,195.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.64,204.28a2.25,2.25,0,0,0,.72.11,12,12,0,0,0,2,0,19.13,19.13,0,0,0,11.82-5,13.56,13.56,0,0,0,1.36-1.43,2.47,2.47,0,0,0,.42-.59c-.06,0-.74.72-2,1.78a21.1,21.1,0,0,1-11.63,4.9C257.67,204.26,256.65,204.2,256.64,204.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.79,196a9.79,9.79,0,0,0,1,2.14,23.91,23.91,0,0,0,3.25,4.53,21.84,21.84,0,0,0,4.13,3.52,7.2,7.2,0,0,0,1.93,1c0-.06-.69-.49-1.79-1.3a27.35,27.35,0,0,1-4-3.57A29.09,29.09,0,0,1,309,198,21.15,21.15,0,0,0,307.79,196Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.17,65.27c-1.79.51-5.52-1.8-7.08-2.81A8.32,8.32,0,0,0,305,60.93a28,28,0,0,0-3.86.24,2.32,2.32,0,0,1-2.17-1l0-1.37,7.44-1.51,5.09,2.5Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.74,65.56a22.56,22.56,0,0,1-3.54,0c-3-.11-4.4-2.4-5.2-3S305,59.42,305,59.42l-6.52.94a33.33,33.33,0,0,1-3.88.19,1.34,1.34,0,0,1-1.3-1.72s11.85-3.5,12.12-4c.89-1.56,3.08-1,4-.8S324.92,60,324.92,60L320,66.28Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.74,65.56a1.41,1.41,0,0,1,.34.15l1,.51H320l4.82-6.34.08.27-11-4.17-3.24-1.21a13.18,13.18,0,0,0-1.68-.55,5.76,5.76,0,0,0-1.74-.18,2,2,0,0,0-1.47.69l-.12.17a.86.86,0,0,1-.22.22,3.26,3.26,0,0,1-.49.25l-.91.34c-1.21.43-2.45.83-3.71,1.23-2.39.75-4.73,1.46-7,2.12l.17-.18a1.08,1.08,0,0,0,.45,1.24,3.44,3.44,0,0,0,1.57.18c1.12,0,2.25-.11,3.31-.25l6.09-.86H305l.06,0,2.87,1.82,1.33.85a6.66,6.66,0,0,1,1.23.87,11.2,11.2,0,0,0,2,1.76,5.61,5.61,0,0,0,2,.82,31.22,31.22,0,0,0,3.14.19l.83,0a1.94,1.94,0,0,1,.28,0,3.8,3.8,0,0,1-1.11.11,24.67,24.67,0,0,1-3.18-.08,5.64,5.64,0,0,1-2.16-.81A11.78,11.78,0,0,1,310.24,63a6.38,6.38,0,0,0-1.19-.82l-1.33-.82-2.88-1.78.14,0-6.09.91c-1.09.15-2.2.22-3.36.27a3.82,3.82,0,0,1-1.82-.23,1.36,1.36,0,0,1-.67-.8,2,2,0,0,1,0-1l0-.13.15-.05c2.25-.67,4.59-1.38,7-2.13,1.26-.4,2.5-.79,3.7-1.22.3-.1.59-.22.88-.33a2.53,2.53,0,0,0,.36-.17s0,0,.09,0c-.06,0,0-.08,0-.12l.15-.22a2.52,2.52,0,0,1,1.83-.86,8.55,8.55,0,0,1,3.63.76l3.24,1.24L325,59.84l.23.08-.15.19-5,6.21,0,.06,0,0-.92-.56A1.42,1.42,0,0,1,318.74,65.56Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.61,64.13a2.22,2.22,0,0,1-.42,0,4.5,4.5,0,0,1-1.14-.39,8.1,8.1,0,0,1-3.14-3.09l.14.1-2.19-.31a3.73,3.73,0,0,1-2.1-1.52l.17.1-2.57-.25h.07c-1.33.28-2.76.57-4.25.82l-.95.14a2.75,2.75,0,0,1-1,0,2.17,2.17,0,0,1-1.47-1.35l-.1-.25.26-.08a88.19,88.19,0,0,1,9.37-2.6l-.14.14a1.61,1.61,0,0,1,1.26-1.31,3,3,0,0,1,1.34.08,6.22,6.22,0,0,1,.77.29q.25.12.24.15s-.37-.12-1.05-.26a2.86,2.86,0,0,0-1.24,0,1.3,1.3,0,0,0-1,1.09l0,.12-.12,0c-2.34.54-5.58,1.56-9.27,2.76l.16-.33a1.7,1.7,0,0,0,1.11,1,6.19,6.19,0,0,0,1.77-.14c1.48-.25,2.91-.54,4.24-.81h.08l2.57.28h.11l.06.09A3.42,3.42,0,0,0,308,60l2.16.36h.1l.05.09a8.34,8.34,0,0,0,2.89,3.08A11,11,0,0,0,314.61,64.13Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.07,98l26-13.08-1.15-2L318.64,68.12l8.07-10.84L347,75.82c9.08,10.57,5.5,15.2-.39,20.63L330,109.72l-16.07,11.72Z",
    style: {
      fill: "#AE460C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.55,102.15a17.64,17.64,0,0,1-.42,2.84c-.29,1.74-.67,4.15-.95,6.83s-.43,5.11-.51,6.88a19.56,19.56,0,0,1-.18,2.86,12.7,12.7,0,0,1-.18-2.87,60.41,60.41,0,0,1,.35-6.93,62.8,62.8,0,0,1,1.11-6.84A13.62,13.62,0,0,1,319.55,102.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344,87a20.3,20.3,0,0,1-4.46-.88,19.94,19.94,0,0,1-4.32-1.39,19.59,19.59,0,0,1,4.45.88A20.15,20.15,0,0,1,344,87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.73,94.68,282.39,103l6.75,8.57,2.47-8.89,1.77-7,2.9,2.88,7.36,15.67L311.92,190s-14.44,4.23-21.92,4.75-19.39-1.54-19.39-1.54V153.39l-4.25-39.47,5.12-15.12Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.27,194.28s0-.07,0-.21l0-.63c0-.56-.05-1.37-.09-2.4-.07-2.1-.17-5.11-.29-8.82-.26-7.46-.67-17.75-1.26-29.11s-1.24-21.65-1.76-29.09c-.25-3.71-.46-6.71-.61-8.81-.07-1-.12-1.83-.16-2.4,0-.26,0-.47,0-.62V112a.71.71,0,0,1,0,.21l.06.63c.05.56.13,1.36.22,2.39.19,2.07.43,5.08.71,8.8.57,7.44,1.26,17.72,1.85,29.09s1,21.66,1.17,29.12c.1,3.73.16,6.75.19,8.83q0,1.54,0,2.4v.63A.67.67,0,0,1,293.27,194.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.07,98.61,267.6,102l-20.19,10.63,11.24,34.27,3,19.22-11.35,45.66s13.78,4.74,15,3.22a63.58,63.58,0,0,0,3.46-7.51,80.91,80.91,0,0,0,5.78-22.43c.84-7.77,1.61-17.68,1.05-24.39-1.06-12.56-2.73-33.29-2.88-38.74s-1.11-26-1.11-26Z",
    style: {
      fill: "#AE460C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.64,95.92l6.17,3,11-1.48,6.74,18.86-.26,45.21L327.21,210s-7.27,2.57-10.14,1.51-6.81-7.56-7-11.5S304.35,158,304.35,158l-5.44-51.31Z",
    style: {
      fill: "#AE460C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.9,100.48s.1.09.27.3l.75.92,2.78,3.48.06.07-.08.06-2.35,1.78,0-.19,2.76.87.09,0v.09c-.05,4.92-.12,11.12-.19,17.84-.12,8.2-.23,15.62-.31,21-.05,2.67-.09,4.84-.12,6.37,0,.73,0,1.31-.06,1.73,0,.18,0,.33,0,.45a.85.85,0,0,1,0,.15s0,0,0-.15,0-.27,0-.45c0-.42,0-1,0-1.73,0-1.53,0-3.7,0-6.37.06-5.4.14-12.83.22-21,.09-6.72.18-12.92.25-17.84l.09.12-2.75-.9L303,107l.17-.12,2.38-1.76,0,.13-2.71-3.53-.71-1A2.09,2.09,0,0,1,301.9,100.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275,154.17s0,0-.05-.15l-.15-.44c-.13-.41-.31-1-.55-1.69-.48-1.47-1.2-3.6-2.12-6.21-.47-1.31-1-2.73-1.52-4.26s-1.09-3.2-1.56-5a113.4,113.4,0,0,1-2.16-11.72c-.75-5.46-1.24-10.6-1.53-15v-.06l.05,0,2.38-2.29v.19l-2.26-1.72-.08-.07.06-.08c1.71-2.32,3.1-4.2,4.07-5.53l1.12-1.49c.13-.15.22-.28.3-.38l.11-.13s0,.06-.08.15l-.27.4-1.08,1.53-4,5.58,0-.16,2.27,1.7.11.09-.1.1-2.36,2.31,0-.11c.32,4.42.82,9.56,1.56,15a118.22,118.22,0,0,0,2.14,11.7c.46,1.77,1,3.43,1.52,5s1,3,1.49,4.28c.89,2.62,1.58,4.76,2,6.24.22.74.39,1.32.49,1.71l.12.45C275,154.12,275,154.17,275,154.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.89,111.28a5.44,5.44,0,0,1-.57-.51l-1.5-1.49c-1.3-1.33-3.05-3.13-5.07-5.18H282a6.23,6.23,0,0,0-1.3,2.78,6.08,6.08,0,0,0-.13,1.63l0,.35-.27-.22c-2.56-2.08-4.64-4.12-6.19-5.51l-1.83-1.64a5.62,5.62,0,0,1-.66-.6,4.21,4.21,0,0,1,.73.52c.46.35,1.1.88,1.89,1.57,1.6,1.35,3.7,3.36,6.25,5.42l-.25.13a6.65,6.65,0,0,1,.13-1.71,6.46,6.46,0,0,1,1.39-2.92l.11-.12.11.11,5,5.26,1.44,1.56A4.37,4.37,0,0,1,288.89,111.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.67,100a1.43,1.43,0,0,1,0,.47c0,.31,0,.77-.06,1.33a28.05,28.05,0,0,1-.76,4.57l-.09.38-.18-.35a11.26,11.26,0,0,0-2-2.71c-.23-.22-.46-.44-.68-.63l.25-.09a41.73,41.73,0,0,1-1.84,6.06c-.29.74-.54,1.33-.73,1.73a2.71,2.71,0,0,1-.32.61,3.08,3.08,0,0,1,.22-.65l.64-1.77a53.07,53.07,0,0,0,1.73-6l.05-.25.2.17c.23.2.47.42.7.66a10.69,10.69,0,0,1,2,2.79l-.27,0a33.86,33.86,0,0,0,.86-4.51C295.59,100.62,295.64,100,295.67,100Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312.1 180.21 313.9 185.81 324.12 184.87 320.93 179.51 312.1 180.21",
    style: {
      fill: "#AE460C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.1,180.21a3.75,3.75,0,0,1,.61-.08l1.78-.18c1.55-.15,3.78-.36,6.43-.58H321l0,.08,3.2,5.35.12.21-.24,0-.53,0-9.69.86h-.09l0-.09c-.55-1.75-1-3.18-1.27-4.15-.13-.46-.24-.83-.33-1.12a2.12,2.12,0,0,1-.09-.37,3.46,3.46,0,0,1,.16.41l.39,1.12c.34,1,.8,2.37,1.37,4l-.13-.09,9.69-.93.52,0L324,185l-3.17-5.37.13.07c-2.58.19-4.77.33-6.33.42l-1.83.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M306,107.89l1.68,2.32s-.47,35.23-2.26,44Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M236,173.63a62.66,62.66,0,0,1-1.13-7.2,40.17,40.17,0,0,1,.36-6.2c.84-7,12.28-47.57,12.28-47.57l11.51,31.62-6,21,6.86,42-16,3.21S238.3,183.17,236,173.63Z",
    style: {
      fill: "#AE460C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.41,242.91s2-19.75,6.61-22,11-3.71,12.77-.77a34.9,34.9,0,0,1,4.35,12.09,75.33,75.33,0,0,1,.39,11.93l-5.27-.55s.11-19.66-1.51-22.56-9.71-.5-10.58,3-2.69,19.24-2.69,19.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.28,270.86c.19-8.14.83-26.09,1.12-34a4,4,0,0,1,4-3.86l48.4-.07a4,4,0,0,1,4,3.86L286,270.23a4,4,0,0,1-4,4.15l-50.71.58A4,4,0,0,1,227.28,270.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.51,245.21s0,.11,0,.35,0,.62,0,1.08c0,1,0,2.37,0,4.18,0,3.66,0,8.93,0,15.44v1.23a2.45,2.45,0,0,1-.27,1.29,2.26,2.26,0,0,1-1,.92,3,3,0,0,1-1.35.21l-5.53,0-12.21.07-13.5.07-7.13,0-3.65,0H236a3.94,3.94,0,0,1-1-.05,2.25,2.25,0,0,1-1.53-1.22,2.36,2.36,0,0,1-.21-.83c0-.29,0-.54,0-.81,0-.53,0-1.06,0-1.59,0-1.05,0-2.1,0-3.14,0-2.08.06-4.14.08-6.16.06-4,.12-8,.17-11.69v-.18h.18c13.91.75,25.84.89,34.28.86,4.23,0,7.58-.05,9.87-.09l2.65,0h.67a.72.72,0,0,1,.22,0h-.24l-.68,0-2.62.1c-2.29.07-5.64.15-9.86.19-8.45.09-20.39,0-34.31-.73l.18-.17c0,3.74-.1,7.65-.15,11.7,0,2-.05,4.07-.08,6.15,0,1.05,0,2.09,0,3.15,0,.53,0,1.05,0,1.58a3,3,0,0,0,.17,1.49,1.91,1.91,0,0,0,1.28,1,4.07,4.07,0,0,0,.87,0h.93l3.65,0,7.13,0,13.49,0,12.21,0H279a2.5,2.5,0,0,0,1.23-.18,1.93,1.93,0,0,0,.87-.8,2.18,2.18,0,0,0,.25-1.15v-1.23c.05-6.48.09-11.73.12-15.37,0-1.82,0-3.23.05-4.21,0-.47,0-.84,0-1.1S281.51,245.21,281.51,245.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.76,266.78s.3,0,.85-.12a4.27,4.27,0,0,0,2.08-1.18,4.37,4.37,0,0,0,1.16-3.52c0-1.52,0-3.25,0-5.16,0-1,0-2,0-3a4.25,4.25,0,0,0-.88-3,4,4,0,0,0-2.89-1.51c-1.17,0-2.42,0-3.68,0H247.93a4,4,0,0,0-4,3.86c0,.7,0,1.39,0,2.08,0,1.37,0,2.72,0,4.05,0,.66,0,1.31,0,2a16.78,16.78,0,0,0,0,1.89,4,4,0,0,0,1.91,2.85,3.87,3.87,0,0,0,1.59.55c.55.06,1.14,0,1.7,0l6.25,0,9.05.08,2.46,0,.64,0,.22,0a.89.89,0,0,1-.22,0l-.64,0-2.46,0-9.05,0h-6.25c-.57,0-1.12,0-1.73,0a4.33,4.33,0,0,1-3.8-3.66,15.76,15.76,0,0,1-.05-1.94v-6c0-.69,0-1.39,0-2.09a4.36,4.36,0,0,1,4.36-4.22l16.44.05c1.27,0,2.49,0,3.7,0a4.31,4.31,0,0,1,3.1,1.64,4.54,4.54,0,0,1,.93,3.14c0,1,0,2,0,3,0,1.91,0,3.64,0,5.16a10.2,10.2,0,0,1,0,1.11,4.57,4.57,0,0,1-.24,1,4.24,4.24,0,0,1-3.15,2.66A3.29,3.29,0,0,1,267.76,266.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M234.84,269.92a77.37,77.37,0,0,0,44.31-.22Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M262.15,254.38h-5.71a1.63,1.63,0,0,1-1.62-1.62h0a1.63,1.63,0,0,1,1.63-1.62h5.71a1.62,1.62,0,0,1,1.62,1.62h0A1.62,1.62,0,0,1,262.15,254.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.24,214.35a17.13,17.13,0,0,1,2.46,3.16,47,47,0,0,1,1.44,6.62s-1,.82-2.58-2.09a25.8,25.8,0,0,1-2-4.34Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.07,224.25l-1.73-9.78-5.83-7-11.37,2.3,2,12.28s2.76,4.71,3.78,5.5,2.56-.25,2.56-.25c1.18,1.23,3.54.22,3.54.22,1.51,1.2,3.12-.53,3.12-.53s1.95,1.18,2.69.93a1.53,1.53,0,0,0,.7-.67A4.25,4.25,0,0,0,265.07,224.25Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.05,225c.11-.06.49.4.85,1s.58,1.2.48,1.26-.49-.41-.86-1S252.94,225,253.05,225Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.11,224.19c.12,0,.48.75,1,1.69a6.56,6.56,0,0,1,.83,1.76c-.09.07-.71-.58-1.22-1.56A3.55,3.55,0,0,1,256.11,224.19Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.69,223.81c.12,0,.37.69.71,1.56s.67,1.55.57,1.62-.61-.55-1-1.46S259.57,223.83,259.69,223.81Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.81,217.55a32,32,0,0,1,1.38,7.42,32,32,0,0,1-1.38-7.42Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.49,223s0,.19-.19.36a1.36,1.36,0,0,1-.92.33,1.27,1.27,0,0,1-.9-.35c-.19-.17-.23-.33-.19-.36s.51.27,1.1.27S252.4,223,252.49,223Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.2,222.9s0,.2-.25.36a1.71,1.71,0,0,1-1,.3,1.62,1.62,0,0,1-1-.31c-.22-.16-.29-.32-.25-.36s.56.24,1.24.23S256.12,222.81,256.2,222.9Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.94,220.81c0-.06.33.21.13.68a2.09,2.09,0,0,1-1.31,1,2.52,2.52,0,0,1-1.63,0c-.39-.15-.57-.35-.54-.4a4.9,4.9,0,0,0,2,0,2.33,2.33,0,0,0,1.17-.72C263,221.07,262.89,220.84,262.94,220.81Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.67,166.13c-.14,0-2.16-10.42-4.51-23.32s-4.15-23.4-4-23.42,2.16,10.41,4.51,23.32S261.82,166.1,261.67,166.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,165.28a2.5,2.5,0,0,1,.15.58c.09.45.19,1,.32,1.69.28,1.54.65,3.65,1.1,6.22.89,5.32,2.1,12.55,3.43,20.55.75,4.68,1.47,9.1,2.09,13l0,.23-.22,0-11.59,2.23-3.29.59a6.36,6.36,0,0,1-1.17.16,7.28,7.28,0,0,1,1.14-.3l3.26-.72,11.56-2.42-.18.27c-.64-3.87-1.37-8.28-2.14-13-1.28-8-2.43-15.24-3.28-20.57-.39-2.59-.7-4.7-.94-6.25-.09-.69-.16-1.25-.22-1.7A2.46,2.46,0,0,1,253,165.28Z",
    style: {
      fill: "#263238"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard3);
export default __webpack_public_path__ + "static/media/card-3.8f521691b7491ebf3869b16a06afbb2a.svg";
export { ForwardRef as ReactComponent };